/* flower-poster-section.js
 * Front-end controller for the flower-bouquet builder (sections/flower-poster.liquid).
 * EXTRACTED from the section's inline <script> so the .liquid file stays under Shopify's
 * section-file size limit (the inline version pushed it to ~130KB and Shopify then
 * refused to render the section: "section file ... does not exist").
 * Fully self-contained: no Liquid, reads config from the inline JSON <script> tags
 * (#fb-flowers-json, #fb-product-json, #fb-position-overrides, #fb-palette-url) via the
 * DOM, boots on DOMContentLoaded, and re-boots on shopify:section:load (idempotent hook).
 * MUST load with defer AFTER flower-poster-renderer.js.
 */
(function () {
  "use strict";

  var FB_SECTION_VERSION = "v2026-08-03.1";

  function fbBoot() {
  console.log("[FB] ===== Script started ===== " + FB_SECTION_VERSION + " | renderer: " + (window.FlowerBouquetRenderer && window.FlowerBouquetRenderer.VERSION || "not loaded yet"));
  // The theme editor re-renders this section on every setting change, so fbBoot can run
  // more than once (re-executed inline script AND the shopify:section:load hook). Guard:
  // wire each DOM instance exactly once, and tear down the previous instance's
  // window-level listeners -- element listeners die with the replaced DOM, window ones stack.
  var bootCanvas = document.getElementById("fb-canvas");
  if (!bootCanvas || bootCanvas.dataset.fbBooted) return;
  bootCanvas.dataset.fbBooted = "1";
  if (window.__fbTeardown) { try { window.__fbTeardown(); } catch (e) {} }

  // ------------------------------------------------------------
  // i18n: customer-facing UI strings are localized in the theme's
  // locale files (flower_bouquet.*) and emitted into #fb-i18n by the
  // section. t(key, fallback) returns the localized string, falling back
  // to the English literal if the tag or key is missing -- so a lagging
  // locale can never break the builder. Interpolate "{n}" via .replace.
  // ------------------------------------------------------------
  var FB_I18N = (function () {
    try { return JSON.parse(document.getElementById("fb-i18n")?.textContent || "{}") || {}; }
    catch (e) { return {}; }
  })();
  function t(key, fallback) {
    var v = FB_I18N[key];
    return (typeof v === "string" && v) ? v : fallback;
  }

  // ============================================================
  // A) BOOTSTRAP
  // ============================================================
  const R = window.FlowerBouquetRenderer;
  if (!R) { console.warn("[FB] flower-poster-renderer.js not loaded – UI will work but canvas preview disabled."); }

  // Wait for palette
  function waitForPalette(tries, delay) {
    tries = tries || 60; delay = delay || 50;
    return new Promise(resolve => {
      let n = 0;
      const tick = () => {
        const p = window.SingleFlowerPosterPalette;
        if (p && Array.isArray(p.colors) && p.colors.length) return resolve(p.colors);
        if (++n >= tries) return resolve(null);
        setTimeout(tick, delay);
      };
      tick();
    });
  }

  // Load palette JSON
  var _paletteUrl = document.getElementById("fb-palette-url")?.textContent?.trim() || "";
  if (_paletteUrl && window.SingleFlowerPosterPalette && window.SingleFlowerPosterPalette.loadFromUrl) {
    window.SingleFlowerPosterPalette.loadFromUrl(_paletteUrl);
  }

  // Saved position overrides (pasted from Dev mode into settings). The renderer's baked
  // built-ins ARE the "original" style's calibration; the section-level setting is a
  // base layer on top of that, and each bouquet STYLE (background block / neutral) can
  // carry its own overrides applied last -- so styles have independent position sets.
  // Any blob may carry "globalScale" -- a multiplier applied to every flower's size.
  var globalScale = (R && R.DEFAULT_GLOBAL_SCALE) || 1;

  // Base layer: the section-level "Position overrides (JSON)" setting plus this tab's
  // unsaved tuning-session backup. Re-run on every style switch (after a full reset).
  function applyBaseAdjustments() {
    if (!R || !R.setTemplateOverrides) return;
    try {
      var ovRaw = JSON.parse(document.getElementById("fb-position-overrides")?.textContent || '""');
      var overrides = ovRaw ? JSON.parse(ovRaw) : null;
      if (overrides) {
        R.setTemplateOverrides(overrides);
        if (typeof overrides.globalScale === "number" && overrides.globalScale > 0) globalScale = overrides.globalScale;
      }
    } catch (e) { console.warn("[FB] position_overrides parse error:", e); }
    // Restore this tab's unsaved tuning session (saved on every dev-mode change) on
    // top of the persisted setting -- protects against reloads mid-session. BUT: if the
    // setting's content has CHANGED since the backup was taken (merchant hand-edited or
    // re-pasted it), the setting is the newer intent -- drop the stale backup instead of
    // letting it silently clobber the edited setting on every reload.
    try {
      var settingRaw = document.getElementById("fb-position-overrides")?.textContent || "";
      // PER-STYLE backup slots (2026-07-17): each style keeps its OWN tuning-session
      // backup under "fb-dev-adjustments::<styleKey>", so switching between Bouquet
      // and Minimal restores each style's in-progress layout independently. (The old
      // single shared slot made a style switch overwrite the other style's session.)
      // sessionStorage is the primary backup (per-tab); localStorage is the crash net.
      var curStyleKey = SELECTED_BG_KEY || "minimal";
      var slotKey = "fb-dev-adjustments::" + curStyleKey;
      var store = sessionStorage.getItem(slotKey) !== null ? sessionStorage : localStorage;
      var raw = store.getItem(slotKey);
      var legacy = false;
      if (raw === null) {
        // Legacy pre-per-style slot: adopt it for the style it belongs to (its _style
        // stamp; stampless = whatever style is current, old behavior).
        var lstore = sessionStorage.getItem("fb-dev-adjustments") !== null ? sessionStorage : localStorage;
        var lraw = lstore.getItem("fb-dev-adjustments");
        if (lraw !== null) {
          try {
            var lp = JSON.parse(lraw);
            if (!lp || !lp._style || lp._style === curStyleKey) { raw = lraw; store = lstore; legacy = true; }
          } catch (eL) {}
        }
      }
      var basedonKey = legacy ? "fb-dev-adjustments-basedon" : (slotKey + "-basedon");
      var versionKey = legacy ? "fb-dev-adjustments-version" : (slotKey + "-version");
      var backupBase = store.getItem(basedonKey);
      var backupVer = store.getItem(versionKey);
      // A backup is only trusted if it RECORDED the setting it was based on AND that
      // setting is unchanged AND it was taken against THIS renderer version. The version
      // guard is what detects BAKES: baking changes the baked baseline but leaves the
      // (empty) setting untouched, so the basedon check alone let pre-bake backups
      // silently re-apply old positions forever (the 2026-07-17 Mac-vs-PC mystery).
      // NEVER delete tuning data -- park stale backups under a recovery key instead
      // (console: localStorage keys starting with "fb-dev-adjustments-stale").
      var curVer = String((R && R.VERSION) || "");
      if (raw !== null && (backupBase !== settingRaw || backupVer !== curVer)) {
        try { localStorage.setItem("fb-dev-adjustments-stale::" + curStyleKey, raw); } catch (e2) {}
        var clearKeys = legacy
          ? ["fb-dev-adjustments", "fb-dev-adjustments-basedon", "fb-dev-adjustments-version"]
          : [slotKey, slotKey + "-basedon", slotKey + "-version"];
        clearKeys.forEach(function (k) { sessionStorage.removeItem(k); localStorage.removeItem(k); });
        raw = null;
        console.log("[FB] Stale backup NOT applied (" + (backupVer !== curVer ? "taken against renderer " + (backupVer || "unknown") + ", now " + curVer + " -- a bake supersedes it" : "setting is authoritative") + ") -- parked at localStorage 'fb-dev-adjustments-stale::" + curStyleKey + "'.");
      }
      var sessAdj = raw ? JSON.parse(raw) : null;
      if (sessAdj) {
        _backupAppliedForStyle[curStyleKey] = true;
        R.setTemplateOverrides(sessAdj);
        if (typeof sessAdj.globalScale === "number" && sessAdj.globalScale > 0) globalScale = sessAdj.globalScale;
        console.log("[FB] " + (store === sessionStorage ? "Session" : "localStorage (crash-recovery)") + " backup applied for style '" + curStyleKey + "'" + (legacy ? " (migrated from the legacy shared slot)" : "") + ". Keys:", Object.keys(sessAdj).join(", "));
        if (legacy) {
          // Migrate: copy into the per-style slot, retire the shared one.
          try {
            sessionStorage.setItem(slotKey, raw); sessionStorage.setItem(slotKey + "-basedon", backupBase || ""); sessionStorage.setItem(slotKey + "-version", backupVer || "");
            localStorage.setItem(slotKey, raw); localStorage.setItem(slotKey + "-basedon", backupBase || ""); localStorage.setItem(slotKey + "-version", backupVer || "");
            ["fb-dev-adjustments", "fb-dev-adjustments-basedon", "fb-dev-adjustments-version"].forEach(function (k) { sessionStorage.removeItem(k); localStorage.removeItem(k); });
          } catch (eM) {}
        }
      }
    } catch (e) {}
  }

  // Manually loaded dev snapshots, PER STYLE (2026-07-17): re-applied LAST in
  // applyStyleAdjustments so the full reset on boot / style switches doesn't wipe
  // them -- and each style only re-applies ITS OWN loaded snapshot, so switching
  // Bouquet <-> Minimal always shows the right layout.
  var loadedSnapshotByStyle = {};
  // Which styles had a session backup applied this boot -- when a style has NO
  // live session, its saved snapshot auto-loads instead (dev only, see below).
  var _backupAppliedForStyle = {};

  // Full stack for the currently selected style: factory reset -> base layer -> the
  // style's own "Position overrides (JSON)" -> a manually loaded snapshot (if any).
  // Called at boot and on every style switch.
  function applyStyleAdjustments() {
    if (!R || !R.setTemplateOverrides) return;
    if (R.resetAllAdjustments) R.resetAllAdjustments();
    globalScale = R.DEFAULT_GLOBAL_SCALE || 1;
    // Completed styles are baked INTO the renderer (BAKED_STYLE_OVERRIDES, shared
    // with the admin poster review). Applied first; the layers below are dev-time
    // scratch space on top.
    if (R.applyBakedStyleOverrides) R.applyBakedStyleOverrides(SELECTED_BG_KEY || "minimal");
    applyBaseAdjustments();
    var st = selectedStyle();
    if (st.overridesRaw) {
      try {
        var so = JSON.parse(st.overridesRaw);
        if (so) {
          R.setTemplateOverrides(so);
          if (typeof so.globalScale === "number" && so.globalScale > 0) globalScale = so.globalScale;
        }
      } catch (e) { console.warn("[FB] style position_overrides parse error (" + (st.key || "neutral") + "):", e); }
    }
    // SNAPSHOT AUTO-LOAD (merchant 2026-07-17: "I need the snapshot to work for
    // each style"): in dev, when a style has no live session backup (e.g. a deploy
    // parked it) but HAS a saved snapshot, the snapshot applies automatically on
    // selecting that style -- the manual save is the durable per-style state.
    // A live session backup always wins (it's newer than the save point).
    var _autoSk = SELECTED_BG_KEY || "minimal";
    if (DEV_TOOLS_ENABLED && !loadedSnapshotByStyle[_autoSk] && !_backupAppliedForStyle[_autoSk] && typeof readSavedSnapshot === "function") {
      var _autoSnap = readSavedSnapshot();
      if (_autoSnap && _autoSnap.adjustments && Object.keys(_autoSnap.adjustments).length) {
        loadedSnapshotByStyle[_autoSk] = _autoSnap.adjustments;
        console.log("[FB] Snapshot for style '" + _autoSk + "' auto-loaded (saved " + (_autoSnap.savedAt || "earlier") + ").");
      }
    }
    var loadedSnap = loadedSnapshotByStyle[SELECTED_BG_KEY || "minimal"];
    if (loadedSnap) {
      try {
        R.setTemplateOverrides(loadedSnap);
        if (typeof loadedSnap.globalScale === "number" && loadedSnap.globalScale > 0) globalScale = loadedSnap.globalScale;
        console.log("[FB] Loaded snapshot re-applied after style reset (style '" + (SELECTED_BG_KEY || "minimal") + "').");
      } catch (e) {}
    }
    if (typeof refreshSnapshotStatus === "function") refreshSnapshotStatus();
    if (devGscaleEl) {
      devGscaleEl.value = globalScale;
      if (devGscaleValEl) devGscaleValEl.textContent = globalScale.toFixed(2);
    }
    if (DEV_TOOLS_ENABLED && R.getAdjustmentsJson) console.log("[FB] Active adjustments for style '" + (st.key || "neutral") + "':", JSON.stringify(R.getAdjustmentsJson() || {}));
  }

  // Stem-cutoff band height in DESIGN PIXELS (900-wide design space), PER bouquet
  // background design (each "Bouquet background" block has a "Stem cutoff (px)"
  // setting). The dev slider overrides it live for tuning; save the dialed-in px
  // into that background block's setting to persist. Band color = selected color.
  var stemCutoffOverride = null; // dev-slider value (signed nudge); null = default
  function currentStemCutoff() {
    if (stemCutoffOverride !== null) return stemCutoffOverride;
    // With a background selected, the renderer auto-cuts at the greenery's bottom edge (so
    // the trim is consistent across every poster size). This value is then a SIGNED nudge
    // in design px around that edge -- default 0 = exactly at the greenery bottom.
    if (SELECTED_BG_KEY) return 0;
    // Neutral (no background): there's no greenery edge, so fall back to the section-level
    // "Neutral stem cutoff" as a plain px-from-rect-bottom trim.
    return Number(parsed && parsed.neutralStemCutoff) || 0;
  }

  const rawJson = document.getElementById("fb-flowers-json")?.textContent || "{}";
  let parsed;
  try { parsed = JSON.parse(rawJson); } catch(e) { console.error("[FB] JSON parse error:", e); parsed = {}; }
  const FLOWERS = Object.create(null);

  // A flower block can carry a SECOND painting (its image_2 setting) so that a month
  // picked twice doesn't show the same artwork twice. It is NOT a tile of its own in the
  // picker -- the customer just picks the month. It lives here as a sibling registry
  // entry keyed "<blockId>__v2", cloned from v1 apart from its images, and is handed out
  // by pickVersionedKey(). Its flowerKey carries the same suffix on purpose: a different
  // painting has different proportions, so the renderer must keep a SEPARATE species
  // offset / anchor / scale bucket for it rather than inherit v1's tuning.
  const V2_SUFFIX = "__v2";

  function registerFlower(id, f) {
    FLOWERS[id] = f;
    if (!R) return;
    R.upsertFlower(id, { assetUrl: f.assetUrl, label: f.name || id });
    if (R.upsertFlowerOverride) {
      var ax = Number(f.anchorX); if (!isFinite(ax)) ax = 0.5;
      var ay = Number(f.anchorY); if (!isFinite(ay)) ay = 0.5;
      R.upsertFlowerOverride(id, { stemAnchor: { x: ax, y: ay } });
    }
  }

  (parsed.flowers || []).forEach(f => {
    if (!f || !f.id) { console.warn("[FB] Skipping flower entry (no id):", f); return; }
    var id = String(f.id);
    registerFlower(id, f);
    if (f.assetUrl2) {
      registerFlower(id + V2_SUFFIX, Object.assign({}, f, {
        id: id + V2_SUFFIX,
        flowerKey: String(f.flowerKey || id) + V2_SUFFIX,
        assetUrl: f.assetUrl2,
        thumbUrl: f.thumbUrl2 || f.assetUrl2
      }));
    }
  });

  // The month a registry key belongs to, whichever painting it names.
  function baseFlowerKey(k) {
    k = String(k || "");
    return (k.slice(-V2_SUFFIX.length) === V2_SUFFIX) ? k.slice(0, -V2_SUFFIX.length) : k;
  }

  // Which painting a newly added month gets. Pinned at ADD time and then carried on the
  // person's key, so dragging the list around never repaints anybody. The rule is
  // "whichever version this month currently uses least", which alternates v1, v2, v1,
  // v2 ... on a clean run and still does the sane thing after a removal. A block with no
  // image_2 has no sibling entry, so every occurrence of it stays on v1.
  function pickVersionedKey(id) {
    var v2 = id + V2_SUFFIX;
    if (!FLOWERS[v2]) return id;
    var n1 = 0, n2 = 0;
    people.forEach(function (p) {
      if (baseFlowerKey(p.key) !== id) return;
      if (p.key === v2) n2++; else n1++;
    });
    return (n1 <= n2) ? id : v2;
  }

  // Background — fall back to the single legacy URL if no blocks; otherwise
  // pick the first uploaded background block. With 2+ blocks we render a
  // customer-facing tile selector (see G2 below). With exactly 1 block or
  // 1 legacy setting, no selector is shown and the customer has no choice.
  const BG_LIST = Array.isArray(parsed.backgrounds) ? parsed.backgrounds.filter(b => b && b.imageUrl) : [];
  let BG_URL = String(parsed.backgroundFillUrl || "");

  // ---- Bouquet style activation ----
  // Every style (each background block + the built-in Neutral "None" tile) carries:
  //   devOnly -- only offered in the picker when the section's dev tools are enabled
  //              (the dev template); never on the live storefront.
  //   live    -- live canvas rendering. OFF = the style is selectable but shows its
  //              fixed preview image instead (positions not calibrated yet), and
  //              can't be exported or ordered. Dev mode always renders live so an
  //              inactive style CAN be calibrated.
  // Currently only "original" is live; Neutral shows fixed images.
  //
  // DEV UNLOCK (one-page model, 2026-07-13): the dev markup ships to everyone inside
  // <div id="fb-dev-tools" hidden>. It is revealed only when fbCheckDevUnlock() said
  // yes (theme-editor design mode, or URL #fragment whose SHA-256 matches the
  // dev_token_hash setting) -- the wrapper below fbBoot resolves that BEFORE booting
  // and parks the verdict on window.__fbDevToolsUnlocked.
  var DEV_TOOLS_ENABLED = !!window.__fbDevToolsUnlocked;
  if (DEV_TOOLS_ENABLED) {
    var devToolsWrap = document.getElementById("fb-dev-tools");
    if (devToolsWrap) devToolsWrap.hidden = false;
    // jsPDF is not shipped in the section HTML (customers never need it); inject it
    // once for the PDF export buttons. doExport already waits/errors politely while
    // it loads.
    if (!window.__fbJspdfInjected && parsed.jspdfUrl) {
      window.__fbJspdfInjected = true;
      var jspdfEl = document.createElement("script");
      jspdfEl.src = parsed.jspdfUrl;
      jspdfEl.defer = true;
      document.head.appendChild(jspdfEl);
    }
  }
  const NEUTRAL_STYLE = {
    live: !!parsed.neutralLive,
    devOnly: !!parsed.neutralDevOnly,
    previewUrl: String(parsed.neutralPreviewUrl || ""),
    overridesRaw: String(parsed.neutralOverridesRaw || "")
  };
  function visibleBgList() {
    return BG_LIST.filter(function (b) { return !b.devOnly || DEV_TOOLS_ENABLED; });
  }
  function neutralVisible() {
    return !NEUTRAL_STYLE.devOnly || DEV_TOOLS_ENABLED;
  }
  function selectedStyle() {
    if (SELECTED_BG_KEY === "") {
      // With no background blocks uploaded there IS no picker and "" is the only
      // state -- render live regardless of the neutral flag, or the builder bricks.
      return { key: "", name: "Neutral", live: NEUTRAL_STYLE.live || !visibleBgList().length, previewUrl: NEUTRAL_STYLE.previewUrl, overridesRaw: NEUTRAL_STYLE.overridesRaw, imageUrl: "" };
    }
    var bg = BG_LIST.find(function (b) { return String(b.key || b.id || "") === SELECTED_BG_KEY; });
    if (!bg) return { key: SELECTED_BG_KEY, name: "", live: true, previewUrl: "", overridesRaw: "", imageUrl: "" };
    return { key: SELECTED_BG_KEY, name: bg.name || "", live: bg.live !== false, previewUrl: String(bg.previewUrl || ""), overridesRaw: String(bg.overridesRaw || ""), imageUrl: bg.imageUrl || "" };
  }
  function styleIsLive() { return devMode || !!selectedStyle().live; }

  // Swap the preview area between the live canvas and the style's fixed image, and
  // block everything that depends on a real render (exports, add to cart) while static.
  function updatePreviewMode() {
    var live = styleIsLive();
    var st = selectedStyle();
    var staticEl = document.getElementById("fb-static-preview");
    if (canvas) canvas.style.visibility = live ? "" : "hidden";
    if (staticEl) {
      if (!live) {
        var src = st.previewUrl || st.imageUrl || "";
        if (src && staticEl.getAttribute("src") !== src) staticEl.src = src;
        // No preview uploaded yet: keep the img hidden (empty src renders a broken-image
        // icon in some browsers); the white board + "coming soon" note carry the state.
        staticEl.style.display = src ? "block" : "none";
      } else {
        staticEl.style.display = "none";
      }
    }
    // A fixed image is not the customer's personalized poster: no print files, no order.
    [dlJpgBtn, dlPngBtn, dlPdfBtn, dlPdfNoBleedBtn].forEach(function (b) { if (b) b.style.display = live ? "" : "none"; });
    if (addToCartBtn) {
      addToCartBtn.disabled = !live;
      addToCartBtn.style.opacity = live ? "" : ".5";
    }
    if (statusEl) {
      var comingSoonMsg = t("coming_soon_example", "This design is coming soon – example shown. It can't be ordered yet.");
      if (!live) {
        statusEl.textContent = comingSoonMsg;
        statusEl.style.color = "inherit";
      } else if (statusEl.textContent === comingSoonMsg) {
        statusEl.textContent = "";
      }
    }
    if (live) scheduleRender(); else hideLoader();
  }

  const VISIBLE_BGS = visibleBgList();
  let SELECTED_BG_KEY = VISIBLE_BGS.length ? String(VISIBLE_BGS[0].key || VISIBLE_BGS[0].id || "") : "";
  if (VISIBLE_BGS.length) BG_URL = VISIBLE_BGS[0].imageUrl || BG_URL;
  const BG_KEY = (R && R.BG_KEY) ? R.BG_KEY : "__bg";
  // Paper texture overlay (same settings as the single-flower poster).
  const TEXTURE_KEY = (R && R.TEXTURE_KEY) ? R.TEXTURE_KEY : "__texture";
  const TEXTURE_URL = String(parsed.textureUrl || "");
  const allKeys = Object.keys(FLOWERS);
  if (DEV_TOOLS_ENABLED) console.log("[FB] Loaded", allKeys.length, "flowers:", allKeys, "bg:", !!BG_URL, "bgs:", BG_LIST.length);
  if (R && allKeys.length && R.setDefaultFlowerKey) R.setDefaultFlowerKey(allKeys[0]);

  const PRODUCT_DATA = (() => {
    try { return JSON.parse(document.getElementById("fb-product-json")?.textContent || "{}"); } catch(e) { return {}; }
  })();

  // ============================================================
  // B) DOM REFS
  // ============================================================
  const canvas = document.getElementById("fb-canvas");
  const ctx = canvas ? canvas.getContext("2d", { alpha: true }) : null;
  const loaderEl = document.getElementById("fb-loader");
  const statusEl = document.getElementById("fb-status");

  const colorGrid = document.getElementById("fb-color-grid");
  const sizeInputs = document.querySelectorAll('input[name="fb-size"]');

  const choicesEl = document.getElementById("fb-choices");
  const peopleSlotsEl = document.getElementById("fb-people-slots");
  const peopleCountEl = document.getElementById("fb-people-count");
  const namesListEl = document.getElementById("fb-names-list");

  const dlJpgBtn = document.getElementById("fb-download-jpg");
  const dlPngBtn = document.getElementById("fb-download-png");
  const dlPdfBtn = document.getElementById("fb-download-pdf");
  const dlPdfNoBleedBtn = document.getElementById("fb-download-pdf-nobleed");
  const addToCartBtn = document.getElementById("fb-add-to-cart");

  // ============================================================
  // C) STATE
  // ============================================================
  const IMG_CACHE = Object.create(null);

  // Each entry: { key: "<flowerBlockId>", name: "" } -- ONE ordered list of people.
  // The first two positions map onto the layout's parent0/parent1 anchor slots, the
  // rest onto child0.., so N people always resolve to the baked p1c0/p2c0..p2c10
  // series (1 -> p1c0, 2 -> p2c0, 3 -> p2c1 ... 12 -> p2c10). p0cX/p1cX keys never
  // occur, and the adjustments JSON keeps its familiar keys.
  let people = [];

  let dragSource = null; // { idx: number }

  // Layout ceilings: templates exist up to p2c12 (2 parents + 12 children), but 13/14 are
  // DEV-only calibration counts -- customers never go past 12 (p2c10).
  const MAX_PEOPLE = 14;      // dev ceiling (dev tools / theme editor)
  const MAX_PEOPLE_LIVE = 12; // customer-facing ceiling, unchanged
  var NEUTRAL_MAX = Math.max(1, Math.min(MAX_PEOPLE_LIVE, parseInt(parsed.neutralMaxFlowers, 10) || 8));
  var NEUTRAL_MAX_DEV = Math.max(1, Math.min(MAX_PEOPLE, parseInt(parsed.neutralMaxFlowersDev, 10) || 12));
  // Per-style flower cap: Minimal (no background) uses the neutral caps; each background
  // design carries its own maxFlowers/maxFlowersDev (theme block settings). Dev tools
  // unlocked -> the DEV cap (calibrate higher before raising the LIVE cap); customers -> LIVE.
  function maxPeople() {
    var live, dev;
    if (SELECTED_BG_KEY === "") { live = NEUTRAL_MAX; dev = NEUTRAL_MAX_DEV; }
    else {
      var b = BG_LIST.find(function (x) { return String(x.key || x.id || "") === SELECTED_BG_KEY; });
      live = b && b.maxFlowers; dev = b && b.maxFlowersDev;
    }
    var ceiling = DEV_TOOLS_ENABLED ? MAX_PEOPLE : MAX_PEOPLE_LIVE;
    var m = DEV_TOOLS_ENABLED ? (dev != null ? dev : live) : live;
    m = parseInt(m, 10);
    if (!(m >= 1)) m = ceiling;
    return Math.max(1, Math.min(ceiling, m));
  }
  function personPos(i) { return i < 2 ? ("parent" + i) : ("child" + (i - 2)); }

  // The full `people` list is PRESERVED across style switches (JS session memory) so
  // nothing is lost moving to a lower-capacity style and back. Only the first
  // maxPeople() are "active": shown in the slots, drawn on the poster, validated, and
  // sent with the order. Entries beyond the cap stay hidden and reappear when a
  // higher-capacity style is selected again. Everything customer-facing goes through
  // activePeople(); mutation/persistence keeps operating on the full `people` list.
  function activePeople() { return people.slice(0, maxPeople()); }

  // "No names" checkbox: order the bouquet with only the headline + flowers line.
  // Typed names stay in `people` (unticking brings them back) -- they're just blanked
  // everywhere they would reach the poster or the order.
  const noNamesEl = document.getElementById("fb-no-names");
  function noNames() { return !!(noNamesEl && noNamesEl.checked); }
  function personName(p) { return noNames() ? "" : String((p && p.name) || ""); }

  // ============================================================
  // D) SELECTORS
  // ============================================================
  function getSelectedSize() {
    // Fallback matches the `checked` radio in the section markup (30x40).
    return document.querySelector('input[name="fb-size"]:checked')?.value || "30x40";
  }

  function getSelectedRectColor() {
    const checked = document.querySelector('input[name="fb-rectcolor"]:checked');
    return checked ? checked.value : "#EDEBE7";
  }

  // Per-size people limit: the smallest print can't hold many names legibly, so 30x40
  // maxes out at 8. Above that we bump the customer up to 40x50 and disable 30x40 until
  // they drop back down. Sizes not listed accept the full layout ceiling (MAX_PEOPLE;
  // live is capped at 12 by maxPeople() regardless).
  const SIZE_MAX_PEOPLE = { "30x40": 8 };
  function sizePeopleLimit(size) {
    var m = SIZE_MAX_PEOPLE[size];
    return (m != null) ? m : MAX_PEOPLE;
  }
  // Disable any size that can't hold the current number of names; if the SELECTED size
  // is now over its limit (30x40 past 8), move up to 40x50, reprice + re-render, and say
  // so. We never auto-shrink back down -- once bumped up the customer stays there.
  function enforceSizeConstraints() {
    var n = activePeople().length; // what will actually print, not hidden overflow
    var switched = false;
    sizeInputs.forEach(function (r) {
      var over = n > sizePeopleLimit(r.value);
      r.disabled = over;
      if (over && r.checked) {
        var up = document.querySelector('input[name="fb-size"][value="40x50"]');
        if (up && !up.disabled) { up.checked = true; switched = true; }
      }
    });
    if (switched) {
      statusEl.textContent = t("size_upgraded", "Switched to 40x50 - 30x40 fits at most {n} names.").replace("{n}", sizePeopleLimit("30x40"));
      statusEl.style.color = "crimson";
      updateCartPrice();
      scheduleRender();
    }
    // Keep the price/shipping captions greyed in step with the disabled radios,
    // even when no switch happened.
    updateSizeNotes();
  }

  // Informative line under the flower picker: how many names the CURRENTLY selected
  // style allows (Minimal caps lower than the background designs). Kept in sync from
  // renderSlots(), so it updates on style switch, add/remove, and boot.
  function updateFlowerCapNote() {
    var el = document.getElementById("fb-flower-cap-note");
    if (!el) return;
    el.textContent = t("style_flower_cap", "This style fits up to {n} flowers - one per name.").replace("{n}", maxPeople());
  }

  // ============================================================
  // E) COLOR SWATCHES
  // ============================================================
  async function renderColorSwatches() {
    if (!colorGrid) return;
    const palette = await waitForPalette();
    if (!palette || !palette.length) {
      colorGrid.innerHTML = '<div class="fb-note">' + t("no_colors", "Could not load colors.") + '</div>';
      return;
    }

    colorGrid.innerHTML = palette.map((c, idx) => {
      const checked = c.default ? "checked" : (!palette.some(x => x.default) && idx === 0 ? "checked" : "");
      const label = (c.name || c.hex || "Color").replace(/"/g, "&quot;");
      const hex = c.hex || "#EDEBE7";
      return '<label class="fb-card fb-card--swatch">' +
        '<input type="radio" name="fb-rectcolor" value="' + hex + '" aria-label="' + label + '" ' + checked + '>' +
        '<div class="fb-card__inner"><div class="fb-swatch" style="background:' + hex + ';"></div></div>' +
        '<span class="fb-swatch-tip">' + label + '</span>' +
        '</label>';
    }).join("");

    const refreshSelected = () => {
      document.querySelectorAll("#fb-color-grid .fb-card").forEach(card => {
        const input = card.querySelector('input[type="radio"]');
        card.classList.toggle("is-selected", !!(input && input.checked));
      });
    };

    document.querySelectorAll('input[name="fb-rectcolor"]').forEach(r => {
      r.addEventListener("change", () => { refreshSelected(); scheduleRender(); });
    });
    refreshSelected();
  }

  // ============================================================
  // E2) BACKGROUND DESIGN SELECTOR
  // Only renders when 2+ background blocks are uploaded. With 0 or 1,
  // the user has no choice and the form looks the same as before.
  // ============================================================
  function renderBackgroundPicker() {
    const wrapEl = document.getElementById("fb-bg-picker");
    const gridEl = document.getElementById("fb-bg-grid");
    if (!wrapEl || !gridEl) return;
    // Show whenever at least one background is VISIBLE here (dev-only styles are
    // filtered out on the live storefront): "None" + each upload are the choices.
    var bgs = visibleBgList();
    if (!bgs.length) {
      wrapEl.style.display = "none";
      return;
    }
    wrapEl.style.display = "grid";

    var html = "";
    if (neutralVisible()) {
      var noneActive = SELECTED_BG_KEY === "" ? " is-active" : "";
      html += '<button type="button" class="fb-bg-tile fb-bg-tile--none' + noneActive + '" data-bg-none="1" aria-label="' + t("minimal_aria", "Minimal (no background)").replace(/"/g, "&quot;") + '">' +
        '<span class="fb-bg-tile__label">' + t("minimal", "Minimal") + '</span>' +
        '</button>';
    }
    html += bgs.map((bg, idx) => {
      const active = (String(bg.key || bg.id || "") === SELECTED_BG_KEY) ? " is-active" : "";
      const label = (bg.name || "Design " + (idx + 1)).replace(/"/g, "&quot;");
      const url = bg.imageUrl || "";
      return '<button type="button" class="fb-bg-tile' + active + '"' +
        ' data-bg-key="' + (bg.key || bg.id || "") + '"' +
        ' data-bg-url="' + url + '"' +
        ' aria-label="' + label + '">' +
        '<img src="' + url + '" alt="' + label + '" loading="lazy">' +
        '<span class="fb-bg-tile__label">' + label + '</span>' +
        '</button>';
    }).join("");
    gridEl.innerHTML = html;

    gridEl.querySelectorAll(".fb-bg-tile").forEach(btn => {
      btn.addEventListener("click", async () => {
        if (btn.getAttribute("data-bg-none")) {
          SELECTED_BG_KEY = "";
          BG_URL = "";
        } else {
          const newUrl = btn.getAttribute("data-bg-url") || "";
          if (!newUrl) return;
          SELECTED_BG_KEY = btn.getAttribute("data-bg-key") || "";
          BG_URL = newUrl;
          try {
            await ensureUrlLoaded(BG_KEY, BG_URL);
          } catch (e) { console.warn("[FB] bg switch load failed:", e); }
        }
        // The new style may cap lower than the current one (Minimal < backgrounds).
        // We do NOT drop the extra flowers -- they stay in the list, just hidden, and
        // reappear if the customer switches back to a higher-capacity style. Only the
        // active (first maxPeople()) are shown/rendered/ordered. Reassure the customer
        // their extras are kept rather than deleted.
        var _cap = maxPeople();
        if (people.length > _cap) {
          statusEl.textContent = t("flowers_kept", "Showing {n} on this style — the other {r} are kept and return on a larger design.").replace("{n}", _cap).replace("{r}", (people.length - _cap));
          statusEl.style.color = "#7a4a34";
        } else {
          statusEl.textContent = "";
        }
        // Always rebuild the holders so the slot count matches the NEW style's cap,
        // whether it went down (some hidden) or up (hidden ones reappear).
        renderSlots();
        gridEl.querySelectorAll(".fb-bg-tile").forEach(b => b.classList.remove("is-active"));
        btn.classList.add("is-active");
        // Each design carries its own stem-cutoff px -- drop any dev override and
        // let the newly selected design's value apply.
        stemCutoffOverride = null;
        if (typeof syncDevCutoff === "function") syncDevCutoff();
        // Each style carries its own position set: reset to the baked baseline
        // ( = "original") and apply this style's overrides, then either render
        // live or swap to the style's fixed preview image.
        applyStyleAdjustments();
        if (devMode) refreshDevJson();
        updatePreviewMode();
      });
    });
  }

  // ============================================================
  // F) FLOWER CHOICES GRID
  // ============================================================
  function renderChoices() {
    if (!choicesEl) return;

    // Cards are already rendered server-side via Liquid; just wire up click handlers
    const cards = choicesEl.querySelectorAll(".fb-card");
    cards.forEach(card => {
      card.addEventListener("click", () => {
        const baseId = card.getAttribute("data-key");
        if (!baseId) return;

        // Pin which painting this person gets now, never at render time -- see
        // pickVersionedKey. Cards always carry the v1 (block) key.
        const key = pickVersionedKey(baseId);
        var cmFactor = FLOWERS[key]?.cmFactor || "1.0";
        var direction = FLOWERS[key]?.direction || "right";
        var _cap = maxPeople();
        if (people.length >= _cap) {
          statusEl.textContent = t("max_flowers", "Max {n} flowers (one per person).").replace("{n}", _cap);
          statusEl.style.color = "crimson";
          return;
        }
        people.push({ key, name: "", cmFactor, direction });

        statusEl.textContent = "";
        renderSlots();
        maybePlayReorderDemo();
        scheduleRender();
      });
    });
  }

  // One-time drag-to-reorder demo: when the 2nd flower lands (the first moment
  // reordering means anything), the two tiles slide past each other and back and
  // the hint line pulses. Once per session, never in dev mode (merchant request),
  // and the CSS disables it under prefers-reduced-motion.
  var DEMO_CURSOR_SVG = '<svg viewBox="0 0 24 24" width="28" height="28" aria-hidden="true"><path d="M5 2.5l13.5 7.7-5.9 1.4-1.6 5.9L5 2.5z" fill="#111" stroke="#fff" stroke-width="1.6" stroke-linejoin="round"/></svg>';

  // One-time hint (per browser session, never in dev): a translucent GHOST copy of the
  // first flower -- with a cursor on it -- lifts off, slides one slot over and back, and
  // fades. The real tiles never move, so nothing looks reordered; it just shows the tiles
  // can be dragged. Travel distance (--fb-demo-dx) is measured live.
  function maybePlayReorderDemo() {
    if (DEV_TOOLS_ENABLED || devMode) return;
    if (activePeople().length !== 2) return;
    try {
      if (sessionStorage.getItem("fb-reorder-demo-shown")) return;
      sessionStorage.setItem("fb-reorder-demo-shown", "1");
    } catch (e) { return; }
    setTimeout(function () {
      if (!peopleSlotsEl) return;
      var tiles = peopleSlotsEl.querySelectorAll(".fb-bouquet-item");
      if (tiles.length < 2) return;
      var box = peopleSlotsEl.getBoundingClientRect();
      var r0 = tiles[0].getBoundingClientRect(), r1 = tiles[1].getBoundingClientRect();
      var img0 = tiles[0].querySelector(".fb-bouquet-item__thumb img");
      var thumb = img0 ? img0.getAttribute("src") : "";
      peopleSlotsEl.style.setProperty("--fb-demo-dx", Math.round(r1.left - r0.left) + "px");
      var ghost = document.createElement("div");
      ghost.className = "fb-demo-ghost";
      ghost.style.left = Math.round(r0.left - box.left) + "px";
      ghost.style.top = Math.round(r0.top - box.top) + "px";
      ghost.style.width = Math.round(r0.width) + "px";
      ghost.style.height = Math.round(r0.height) + "px";
      ghost.innerHTML = '<div class="fb-demo-ghost__thumb">' + (thumb ? '<img src="' + thumb + '" alt="">' : '') + '</div>' +
                        '<span class="fb-demo-ghost__cursor">' + DEMO_CURSOR_SVG + '</span>';
      peopleSlotsEl.appendChild(ghost);
      var hint = document.getElementById("fb-reorder-hint");
      void ghost.offsetWidth; // reflow so the animation starts from its first keyframe
      ghost.classList.add("is-running");
      if (hint) hint.classList.add("fb-hint-pulse");
      setTimeout(function () {
        if (ghost && ghost.parentNode) ghost.parentNode.removeChild(ghost);
        if (hint) hint.classList.remove("fb-hint-pulse");
      }, 2400);
    }, 400);
  }

  // ============================================================
  // G) SLOT RENDERING (single People list, drag to reorder)
  // ============================================================

  var DRAG_HANDLE_SVG = '<svg viewBox="0 0 24 24" width="18" height="18" fill="currentColor" aria-hidden="true">' +
    '<circle cx="8" cy="6" r="1.6"/><circle cx="16" cy="6" r="1.6"/>' +
    '<circle cx="8" cy="12" r="1.6"/><circle cx="16" cy="12" r="1.6"/>' +
    '<circle cx="8" cy="18" r="1.6"/><circle cx="16" cy="18" r="1.6"/>' +
    '</svg>';

  // Build a cell DOM node for a flower-tile or placeholder
  function createFlowerCell(item, idx) {
    var cell = document.createElement("div");
    cell.className = "fb-slot-cell";
    var f = FLOWERS[item.key];
    var fname = f?.name || "Flower";
    var thumb = f?.thumbUrl || f?.assetUrl || "";
    cell.innerHTML =
      '<div class="fb-bouquet-item" draggable="true" data-idx="' + idx + '" data-key="' + item.key + '" title="' + t("drag_to_reorder", "Drag to reorder").replace(/"/g, "&quot;") + '">' +
      '<button type="button" class="fb-bouquet-item__remove" aria-label="' + t("remove", "Remove").replace(/"/g, "&quot;") + '">&times;</button>' +
      '<div class="fb-bouquet-item__thumb">' + (thumb ? '<img src="' + thumb + '" alt="' + fname.replace(/"/g, '&quot;') + '" draggable="false">' : '') + '</div>' +
      '<div class="fb-bouquet-item__drag">' + DRAG_HANDLE_SVG + '</div>' +
      '</div>';
    wireFlowerCell(cell, idx);
    return cell;
  }

  function createPlaceholderCell() {
    var cell = document.createElement("div");
    cell.className = "fb-slot-cell";
    cell.innerHTML = '<div class="fb-slot-placeholder"><span class="fb-slot-placeholder__icon">+</span></div>';
    return cell;
  }

  function wireFlowerCell(cell, idx) {
    var item = cell.querySelector(".fb-bouquet-item");
    var btn = cell.querySelector(".fb-bouquet-item__remove");
    // NOTE: cells can be REUSED with a new data-idx (renderSlotGroup's same-key path),
    // so handlers must read the index live from the attribute -- the closure's `idx`
    // can be stale after neighbors shift up, which would remove/drag the wrong flower.
    function liveIdx() {
      var v = parseInt(item.getAttribute("data-idx"), 10);
      return isFinite(v) ? v : idx;
    }
    if (btn) {
      btn.addEventListener("click", function(e) {
        e.stopPropagation();
        var removeAt = liveIdx();
        item.classList.add("fb-removing");
        setTimeout(function() {
          people = people.filter(function(_, j) { return j !== removeAt; });
          renderSlots();
          scheduleRender();
        }, 150);
      });
    }
    if (item) {
      // Dev mode: clicking a tile selects that position for tuning (same as clicking
      // the flower on the canvas, but easier when flowers overlap). Read the idx
      // attribute live -- renderSlotGroup updates data-idx without rewiring handlers.
      item.addEventListener("click", function (e) {
        if (!devMode) return;
        if (e.target && e.target.closest(".fb-bouquet-item__remove")) return;
        var i2 = parseInt(item.getAttribute("data-idx"), 10);
        if (isFinite(i2)) selectDevPos(i2);
      });
      item.addEventListener("dragstart", function(e) {
        dragSource = { idx: liveIdx() };
        item.classList.add("is-dragging");
        e.dataTransfer.effectAllowed = "move";
      });
      item.addEventListener("dragend", function() {
        dragSource = null;
        item.classList.remove("is-dragging");
        document.querySelectorAll(".fb-bouquet-item").forEach(function(el) { el.classList.remove("drag-over"); });
        document.querySelectorAll(".fb-slot-box").forEach(function(el) { el.classList.remove("drag-target"); });
      });
      item.addEventListener("dragover", function(e) {
        e.preventDefault();
        e.dataTransfer.dropEffect = "move";
        item.classList.add("drag-over");
      });
      item.addEventListener("dragleave", function() { item.classList.remove("drag-over"); });
      item.addEventListener("drop", function(e) {
        e.preventDefault();
        item.classList.remove("drag-over");
        if (!dragSource) return;
        handleDrop(dragSource.idx, liveIdx());
        dragSource = null;
      });

      // TOUCH reordering: HTML5 drag events never fire on touchscreens, so drive the same
      // handleDrop() from touch. Press-and-HOLD a tile (~200ms) to pick it up, drag over
      // another tile to target it (reusing the .drag-over / .is-dragging highlight), lift
      // to reorder. A quick swipe (movement before the hold fires) scrolls the page instead.
      var tHold = null, tDragging = false, tStartX = 0, tStartY = 0, tTarget = null;
      function clearTTarget() { if (tTarget) { tTarget.classList.remove("drag-over"); tTarget = null; } }
      function endTouchDrag(commit, x, y) {
        if (tHold) { clearTimeout(tHold); tHold = null; }
        if (tDragging) {
          item.classList.remove("is-dragging");
          if (commit && typeof x === "number") {
            var toIdx = activePeople().length;
            var elt = document.elementFromPoint(x, y);
            var over = elt && elt.closest ? elt.closest(".fb-bouquet-item") : null;
            if (over && over !== item) { var ti = parseInt(over.getAttribute("data-idx"), 10); if (isFinite(ti)) toIdx = ti; }
            handleDrop(liveIdx(), toIdx);
          }
          clearTTarget();
        }
        tDragging = false; dragSource = null;
      }
      item.addEventListener("touchstart", function (e) {
        if (devMode) return; // dev mode uses tap-to-select
        if (e.target && e.target.closest && e.target.closest(".fb-bouquet-item__remove")) return; // let the remove tap through
        if (!e.touches || !e.touches[0]) return;
        var tc = e.touches[0];
        tStartX = tc.clientX; tStartY = tc.clientY; tDragging = false;
        if (tHold) clearTimeout(tHold);
        tHold = setTimeout(function () {
          tDragging = true; dragSource = { idx: liveIdx() };
          item.classList.add("is-dragging");
          if (navigator.vibrate) { try { navigator.vibrate(10); } catch (e2) {} }
        }, 200);
      }, { passive: true });
      item.addEventListener("touchmove", function (e) {
        if (!e.touches || !e.touches[0]) return;
        var tc = e.touches[0];
        if (!tDragging) {
          if (Math.abs(tc.clientX - tStartX) > 10 || Math.abs(tc.clientY - tStartY) > 10) {
            if (tHold) { clearTimeout(tHold); tHold = null; } // moved first -> it's a scroll
          }
          return;
        }
        e.preventDefault(); // picked up: pan, don't scroll
        clearTTarget();
        var elt = document.elementFromPoint(tc.clientX, tc.clientY);
        var over = elt && elt.closest ? elt.closest(".fb-bouquet-item") : null;
        if (over && over !== item) { over.classList.add("drag-over"); tTarget = over; }
      }, { passive: false });
      item.addEventListener("touchend", function (e) {
        var tc = (e.changedTouches && e.changedTouches[0]) || null;
        endTouchDrag(true, tc ? tc.clientX : null, tc ? tc.clientY : null);
      });
      item.addEventListener("touchcancel", function () { endTouchDrag(false); });
    }
  }

  function renderSlotGroup(container, items, maxCount, countEl) {
    if (!container) return;
    countEl.textContent = items.length + "/" + maxCount;
    // Fixed 6-column grid: squares keep a constant size (1/6 of the box) no matter the
    // cap -- extra squares WRAP to a new row rather than stretching the existing ones.
    // The per-cell hairline makes the separators follow only the real squares.

    var cells = container.querySelectorAll(".fb-slot-cell");

    for (var i = 0; i < maxCount; i++) {
      var oldCell = cells[i];
      var hadFlower = oldCell && oldCell.querySelector(".fb-bouquet-item");
      var hasFlower = i < items.length;

      if (hasFlower) {
        var oldKey = hadFlower ? hadFlower.getAttribute("data-key") : null;
        var newKey = items[i].key;
        // Check if this cell already shows the correct flower
        if (hadFlower && oldKey === newKey) {
          // Just update the index attribute -- and clear any leftover animation/drag
          // state. Without this, removing a flower whose neighbor is the SAME species
          // reuses the fading-out cell and the tile stays invisible (no image, no x).
          hadFlower.setAttribute("data-idx", i);
          hadFlower.classList.remove("fb-removing", "fb-entering", "is-dragging", "drag-over");
          continue;
        }
        var newCell = createFlowerCell(items[i], i);
        if (oldCell) {
          container.replaceChild(newCell, oldCell);
        } else {
          container.appendChild(newCell);
        }
      } else {
        if (!hadFlower && oldCell) continue; // already a placeholder
        var phCell = createPlaceholderCell();
        if (oldCell) {
          container.replaceChild(phCell, oldCell);
        } else {
          container.appendChild(phCell);
        }
      }
    }

    // Remove excess cells
    while (container.children.length > maxCount) {
      container.removeChild(container.lastChild);
    }

    // Wire container-level drag/drop (only once)
    if (!container._dragWired) {
      container._dragWired = true;
      container.addEventListener("dragover", function(e) {
        e.preventDefault();
        e.dataTransfer.dropEffect = "move";
        container.classList.add("drag-target");
      });
      container.addEventListener("dragleave", function(e) {
        if (!container.contains(e.relatedTarget)) container.classList.remove("drag-target");
      });
      container.addEventListener("drop", function(e) {
        e.preventDefault();
        container.classList.remove("drag-target");
        if (!dragSource) return;
        var target = e.target.closest(".fb-slot-placeholder") || e.target.closest(".fb-slot-cell");
        if (target || e.target === container) {
          // Dropping on an empty placeholder (or the box itself) = move to the END of
          // the filled VISIBLE slots -- reordering only happens among active slots.
          handleDrop(dragSource.idx, activePeople().length);
          dragSource = null;
        }
      });
    }
  }

  function handleDrop(fromIdx, toIdx) {
    const moved = people[fromIdx];
    if (!moved) return;
    people.splice(fromIdx, 1);
    people.splice(Math.min(toIdx, people.length), 0, moved);
    statusEl.textContent = "";
    renderSlots();
    scheduleRender();
  }

  function renderSlots() {
    renderSlotGroup(peopleSlotsEl, activePeople(), maxPeople(), peopleCountEl);
    renderNamesList();
    syncDevTileHighlight();
    updateFlowerCapNote();
    enforceSizeConstraints();
  }

  if (noNamesEl) noNamesEl.addEventListener("change", function () {
    statusEl.textContent = "";
    renderNamesList();
    scheduleTextRender();
  });

  function renderNamesList() {
    if (!namesListEl) return;
    namesListEl.style.display = noNames() ? "none" : "";
    var act = activePeople();
    if (!act.length) { namesListEl.innerHTML = "&nbsp;"; return; }
    var html = "";
    act.forEach(function(item, i) {
      // Two fixed-width columns ("Person N" | picked flower) so the flower name and the
      // input line up on every row regardless of how long the name is.
      var flowerName = flowerDisplayName(item.key);
      var num = t("person", "Person {n}").replace("{n}", (i + 1));
      var flower = flowerName ? flowerName.replace(/</g, '&lt;') : '';
      html += '<div class="fb-name-row">' +
        '<span class="fb-name-row__num">' + num + '</span>' +
        '<span class="fb-name-row__flower" title="' + flower.replace(/"/g, '&quot;') + '">' + flower + '</span>' +
        '<input type="text" class="fb-name-row__input" data-name-idx="' + i + '" value="' + (item.name || '').replace(/"/g, '&quot;') + '" placeholder="' + t("enter_name", "Enter name").replace(/"/g, '&quot;') + '" maxlength="20">' +
        '</div>';
    });
    namesListEl.innerHTML = html;
    namesListEl.querySelectorAll(".fb-name-row__input").forEach(function(input) {
      input.addEventListener("input", function() {
        var i2 = parseInt(input.getAttribute("data-name-idx"), 10);
        if (people[i2]) people[i2].name = input.value;
        scheduleTextRender();
      });
      // Enter jumps to the next name. Plain Tab / Shift+Tab are left to the browser's
      // native focus order -- the inputs are in document order (the label spans aren't
      // focusable), so Tab already walks name -> name without a click.
      input.addEventListener("keydown", function(e) {
        if (e.key !== "Enter") return;
        var rows = namesListEl.querySelectorAll(".fb-name-row__input");
        var i3 = parseInt(input.getAttribute("data-name-idx"), 10);
        var next = rows[i3 + 1];
        if (next) {
          e.preventDefault();
          next.focus();
          next.select();
        }
      });
    });
  }

  // ============================================================
  // H) IMAGE LOADING
  // ============================================================
  async function ensureUrlLoaded(key, url) {
    if (!key || !url) return;
    var img = IMG_CACHE[key] || new Image();
    IMG_CACHE[key] = img;
    if (img.src === url && img.complete && img.naturalWidth) return;
    if (R && R.loadImageTo) {
      await R.loadImageTo(img, url);
    } else {
      await new Promise((res, rej) => { img.onload = res; img.onerror = rej; img.src = url; });
    }
  }

  async function ensureLoaded(key) {
    var k = String(key || "");
    return ensureUrlLoaded(k, FLOWERS[k]?.assetUrl);
  }

  // Minimal (no-background) leaf: a small decorative element drawn only on the
  // Minimal poster, positioned via the section's "Minimal: leaf ..." settings
  // (live-updates in the theme editor). Loaded under a fixed cache key.
  var LEAF_KEY = "neutral-leaf";
  var NEUTRAL_LEAF = (parsed.neutralLeaf && parsed.neutralLeaf.url) ? parsed.neutralLeaf : null;

  async function ensureAllLoaded() {
    if (BG_URL) { try { await ensureUrlLoaded(BG_KEY, BG_URL); } catch (e) { console.warn("[FB] bg load failed:", e); } }
    if (TEXTURE_URL) { try { await ensureUrlLoaded(TEXTURE_KEY, TEXTURE_URL); } catch (e) { console.warn("[FB] texture load failed:", e); } }
    if (SELECTED_BG_KEY === "" && NEUTRAL_LEAF) {
      try { await ensureUrlLoaded(LEAF_KEY, NEUTRAL_LEAF.url); } catch (e) { console.warn("[FB] leaf load failed:", e); }
    }
    var unique = [...new Set(people.map(f => f.key))];
    for (var i = 0; i < unique.length; i++) {
      await ensureLoaded(unique[i]);
      var stemUrl = FLOWERS[unique[i]]?.stemUrl;
      if (stemUrl) { try { await ensureUrlLoaded("stem:" + unique[i], stemUrl); } catch (e) { console.warn("[FB] stem load failed:", e); } }
    }
  }

  // The paper/shadow texture overlay is OFF for Minimal (no-background) -- Minimal
  // is meant to read clean (merchant 2026-07-17). Only background styles get it.
  function textureActive() { return SELECTED_BG_KEY !== "" && !!TEXTURE_URL; }

  function imagesByKey() {
    var out = Object.create(null);
    Object.keys(IMG_CACHE).forEach(k => {
      if (k === BG_KEY && !BG_URL) return; // "No background" selected -- don't draw the cached one
      if (k === TEXTURE_KEY && !textureActive()) return; // Minimal: no texture overlay
      var img = IMG_CACHE[k];
      if (img && img.complete && img.naturalWidth) out[k] = img;
    });
    return out;
  }

  // ============================================================
  // I) INPUT + STYLE BUILDERS
  // ============================================================
  function getAllFlowers() {
    // Active set only -- hidden overflow (from a lower-cap style) must NOT reach the
    // order or the export filename.
    return activePeople();
  }

  function headlineValue() {
    var el = document.getElementById("fb-headline");
    return el ? String(el.value || "").trim() : "";
  }

  // ---- Poster language (sv/en) ----
  // Switches the flower DISPLAY names everywhere they appear: the choice cards, the
  // "Person 1 – <flower>" labels, the poster's flowers line (via the renderer's label
  // registry) and the order metadata. Block setting `name` = Swedish, `name_en` =
  // English (falls back to Swedish when empty). Default follows the storefront locale.
  var POSTER_LANG = (parsed.defaultLang === "en") ? "en" : "sv";
  function flowerDisplayName(key) {
    var f = FLOWERS[key];
    if (!f) return "";
    return (POSTER_LANG === "en" && f.nameEn) ? String(f.nameEn) : String(f.name || "");
  }
  // The name PRINTED on the poster's flowers line ("Ros"/"Rose") -- separate from the
  // card label, which this store fills with the MONTH ("Juni"). Falls back to the card
  // label until the merchant fills the poster-name fields.
  function posterFlowerName(key) {
    var f = FLOWERS[key];
    if (!f) return "";
    if (POSTER_LANG === "en") return String(f.posterNameEn || f.posterName || f.nameEn || f.name || "");
    return String(f.posterName || f.name || "");
  }
  function applyLanguage() {
    document.querySelectorAll(".fb-lang-btn").forEach(function (b) {
      b.classList.toggle("is-active", b.getAttribute("data-lang") === POSTER_LANG);
    });
    if (choicesEl) choicesEl.querySelectorAll(".fb-card").forEach(function (card) {
      var k = card.getAttribute("data-key");
      var labelEl = card.querySelector(".fb-label");
      var n = flowerDisplayName(k);
      if (labelEl && n) labelEl.textContent = n;
    });
    if (R) allKeys.forEach(function (k) {
      var n = flowerDisplayName(k);
      if (n) R.upsertFlower(k, { label: n });
    });
    renderSlots(); // refreshes the "Person N – <flower>" name-row labels
    scheduleRender();
  }

  function getInput() {
    var selBg = BG_LIST.find(b => String(b.key || b.id || "") === SELECTED_BG_KEY);
    var act = activePeople(); // clamp to the current style's cap; hidden overflow excluded
    // People 1-2 render through the parent0/parent1 anchor slots, the rest through
    // child0.. -- list order IS bouquet order, keys stay the baked p1c0/p2cX series.
    return {
      sizeKey: getSelectedSize(),
      headline: headlineValue(),
      rectColor: getSelectedRectColor(),
      globalScale: globalScale,
      stemCutoffPx: currentStemCutoff(),
      parentsCount: Math.min(act.length, 2),
      childrenCount: Math.max(act.length - 2, 0),
      // Minimal-only leaf element (null on background styles). Hidden until at least
      // one flower is added, so an empty Minimal poster doesn't show a lone leaf.
      // Fractions of the artboard + degrees; values come from the section's leaf settings.
      leaf: (SELECTED_BG_KEY === "" && NEUTRAL_LEAF && act.length > 0) ? {
        key: LEAF_KEY,
        x: Number(NEUTRAL_LEAF.x) || 0.5,
        y: Number(NEUTRAL_LEAF.y) || 0.78,
        scale: Number(NEUTRAL_LEAF.scale) || 0.18,
        rot: Number(NEUTRAL_LEAF.rot) || 0
      } : null,
      bgPlacement: selBg ? {
        anchorX: typeof selBg.anchorX === "number" ? selBg.anchorX : 0.5,
        anchorY: typeof selBg.anchorY === "number" ? selBg.anchorY : 0.5,
        scale:   typeof selBg.scale   === "number" ? selBg.scale   : 1
      } : null,
      flowers: act.map((f, i) => ({
        key: f.key,
        flowerKey: FLOWERS[f.key]?.flowerKey || f.key,
        stemKey: FLOWERS[f.key]?.stemUrl ? ("stem:" + f.key) : null,
        name: personName(f),
        posterName: posterFlowerName(f.key),
        cmFactor: f.cmFactor || "1.0",
        direction: f.direction || FLOWERS[f.key]?.direction || "right",
        role: i < 2 ? "parent" : "child",
        slotIndex: i < 2 ? i : i - 2
      }))
    };
  }

  function getStyle() {
    return {
      rectColor: getSelectedRectColor(),
      posterBgColor: "#FFFFFF",
      textColor: "#111111",
      textureOpacity: (typeof parsed.textureOpacity === "number") ? parsed.textureOpacity : 0.4,
      flowerShadow: true,
      debug: false
    };
  }

  // ============================================================
  // J) RENDER PIPELINE
  // ============================================================
  let renderTimer = null;
  let textTimer = null;

  function showLoader(msg) { loaderEl?.classList.remove("is-hidden"); if (msg) { const t = document.getElementById("fb-loader-text"); if (t) t.textContent = msg; } }
  function hideLoader() { loaderEl?.classList.add("is-hidden"); }

  function validate() {
    // Renderer asset missing/404: the preview is blank, so an order would be placed
    // blind with empty layout metadata -- block it (audit 2026-07-17).
    if (!R) {
      return { ok: false, msg: t("preview_load_error", "The preview could not load – please reload the page and try again.") };
    }
    if (!allKeys.length) return { ok: false, msg: "Add flowers in theme blocks." };
    var act = activePeople(); // validate/order only the visible set, not hidden overflow
    if (!act.length) return { ok: false, msg: t("select_min_flower", "Please select at least 1 flower.") };
    // Name poster with blank names is almost certainly a mistake -- block the order
    // and point at the first empty field (audit 2026-07-17).
    var missing = noNames() ? -1 : act.findIndex(function (p) { return !String(p.name || "").trim(); });
    if (missing !== -1) {
      return {
        ok: false,
        msg: t("name_missing", "Please enter a name for every flower (name {n} is empty).").replace("{n}", (missing + 1))
      };
    }
    return { ok: true, msg: "" };
  }

  function renderPreview() {
    if (!R) return;
    var size = getSelectedSize();
    var mm = R.SIZE_MM[size] || R.SIZE_MM["50x70"];
    canvas.style.aspectRatio = mm.w + " / " + mm.h;
    // Keep the wrap (and thus the reference overlay, which fills the wrap) on the SAME
    // ratio as the canvas -- its CSS default is a fixed 3/4, which only matches 30x40.
    var wrap = canvas.closest(".fb-canvas-wrap");
    if (wrap) wrap.style.aspectRatio = mm.w + " / " + mm.h;
    R.setupPreviewCanvasForSize(canvas, ctx, size, 2);
    lastBouquet = R.renderPoster(ctx, imagesByKey(), getInput(), getStyle());
    // Cross-machine diagnostics: one compact line per render with every flower's
    // RESOLVED position -- copy the [FB-POS] line from two machines and diff them.
    // Dev-gated: getAdjustmentsJson + stringify on every render is real work and
    // console spam that customers shouldn't pay for (audit 2026-07-17).
    if (DEV_TOOLS_ENABLED) try {
      var _adjStr = R.getAdjustmentsJson ? JSON.stringify(R.getAdjustmentsJson() || {}) : "";
      var _hh = 5381; for (var _hi = 0; _hi < _adjStr.length; _hi++) _hh = ((_hh << 5) + _hh + _adjStr.charCodeAt(_hi)) | 0;
      console.log("[FB-POS] " + JSON.stringify({
        v: FB_SECTION_VERSION + "/" + (R.VERSION || "?"),
        style: SELECTED_BG_KEY || "neutral",
        size: getSelectedSize(),
        adjHash: (_hh >>> 0).toString(16),
        gs: Math.round(globalScale * 1000) / 1000,
        slots: (lastBouquet && lastBouquet.slots || []).map(function (s) {
          return [s.pos, s.key, Math.round(s.x * 1000) / 1000, Math.round(s.y * 1000) / 1000,
                  Math.round((s.scale || 1) * 1000) / 1000, Math.round((s.rot || 0) * 1000) / 1000].join("|");
        })
      }));
    } catch (e) {}
    drawDevGuides();
    drawDevSelectionHighlight();
    if (devMode && devSelected) updateDevPanel();
    syncMiniBouquet(); // keep the mobile mini-preview mirror in sync with the live canvas
  }

  // Dev guides: a dashed vertical MIDDLE line (the facing threshold), plus two faint
  // lines marking the "keep native direction" zone (x 0.48-0.52 of the board) --
  // flowers left of the zone auto-face left, right of it auto-face right.
  function drawDevGuides() {
    if (!devMode || !ctx || !R) return;
    var designH = R.designHeightFor(getSelectedSize());
    var cx = R.DESIGN_W / 2;
    var artW = R.DESIGN_W * (1 - 2 * (R.DEFAULT_STYLE.marginSidePct || 0.073));
    var bandHalf = 0.02 * artW;
    ctx.save();
    ctx.setLineDash([8, 6]);
    ctx.lineWidth = 1;
    ctx.strokeStyle = "rgba(43,106,143,.6)";
    ctx.beginPath(); ctx.moveTo(cx, 0); ctx.lineTo(cx, designH); ctx.stroke();
    ctx.setLineDash([3, 5]);
    ctx.strokeStyle = "rgba(43,106,143,.25)";
    ctx.beginPath();
    ctx.moveTo(cx - bandHalf, 0); ctx.lineTo(cx - bandHalf, designH);
    ctx.moveTo(cx + bandHalf, 0); ctx.lineTo(cx + bandHalf, designH);
    ctx.stroke();
    ctx.restore();
  }

  // ============================================================
  // DEV MODE — click a flower, nudge with arrows / +/-, copy the complete
  // adjustments JSON (count baselines + split layouts + per-species offsets).
  // Two adjust modes: "layout" edits the position slot (any flower there),
  // "flower" edits only this species at this position (e.g. Rose at p2c3:child2).
  // ============================================================
  var devMode = false;
  var lastBouquet = null;
  var devSelected = null; // { splitKey, tplIndex, pos, key, flowerKey }

  // Default is "flower" (species offset only). "layout" edits BASE data and must be
  // marked explicitly -- merchant decision 2026-07-04: never touch the baked baseline
  // unless deliberately opted in.
  function getAdjustMode() {
    var r = document.querySelector('input[name="fb-dev-adjmode"]:checked');
    return r ? r.value : "flower";
  }

  // Reference overlay: onion-skin a finished poster (local file, nothing uploaded to
  // Shopify) over the canvas at adjustable opacity, to match positions/scale against it.
  // Pure DOM -- never part of the render, exports, or order data.
  (function () {
    var img = document.getElementById("fb-dev-overlay");
    var file = document.getElementById("fb-dev-overlay-file");
    var op = document.getElementById("fb-dev-overlay-op");
    var opVal = document.getElementById("fb-dev-overlay-op-val");
    var clearBtn = document.getElementById("fb-dev-overlay-clear");
    if (!img) return;
    function revoke() { if (img.src && img.src.indexOf("blob:") === 0) URL.revokeObjectURL(img.src); }
    if (file) file.addEventListener("change", function () {
      var f = file.files && file.files[0];
      if (!f) return;
      revoke();
      img.src = URL.createObjectURL(f);
      img.style.opacity = op ? op.value : 0.5;
      img.style.display = "block";
    });
    if (op) op.addEventListener("input", function () {
      img.style.opacity = op.value;
      if (opVal) opVal.textContent = parseFloat(op.value).toFixed(2);
    });
    if (clearBtn) clearBtn.addEventListener("click", function () {
      revoke();
      img.removeAttribute("src");
      img.style.display = "none";
      if (file) file.value = "";
    });
  })();

  // Step size: Fine/Coarse buttons (or the X key). A toggle instead of a modifier key
  // because the Shopify theme editor swallows Shift/Alt/Ctrl combos before we see them.
  var devCoarse = false;
  function syncStepButtons() {
    var f = document.getElementById("fb-dev-step-fine");
    var c = document.getElementById("fb-dev-step-coarse");
    if (f) f.classList.toggle("is-active", !devCoarse);
    if (c) c.classList.toggle("is-active", devCoarse);
  }
  function setCoarse(v) { devCoarse = !!v; syncStepButtons(); updateDevPanel(); }
  (function () {
    var f = document.getElementById("fb-dev-step-fine");
    var c = document.getElementById("fb-dev-step-coarse");
    if (f) f.addEventListener("click", function () { setCoarse(false); });
    if (c) c.addEventListener("click", function () { setCoarse(true); });
  })();

  // Select a position by its People tile (person index -> parent0/1 or child0..)
  function selectDevPos(personIdx) {
    if (!lastBouquet || !lastBouquet.slots.length) return;
    var pos = personPos(personIdx);
    var slot = lastBouquet.slots.find(function (s) { return s.pos === pos; });
    if (!slot) return;
    devSelected = { splitKey: slot.splitKey, tplIndex: slot.tplIndex, pos: slot.pos, key: slot.key, flowerKey: slot.flowerKey };
    updateDevPanel();
    syncDevTileHighlight();
    scheduleRender();
  }

  // Mirror the current selection onto the slot tiles (red inset ring)
  function syncDevTileHighlight() {
    document.querySelectorAll(".fb-bouquet-item").forEach(function (el) {
      var i2 = parseInt(el.getAttribute("data-idx"), 10);
      el.classList.toggle("is-dev-selected", !!(devMode && devSelected && isFinite(i2) && devSelected.pos === personPos(i2)));
    });
  }

  // ---- Flower-center picker: shows the selected species' image; click where its
  // visual center is. Applies to that flower type EVERYWHERE (all positions/splits)
  // and is saved into the adjustments JSON under "anchors".
  function updateCenterPicker() {
    var wrap = document.getElementById("fb-dev-center");
    var img = document.getElementById("fb-dev-center-img");
    var dot = document.getElementById("fb-dev-center-dot");
    var nameEl = document.getElementById("fb-dev-center-name");
    if (!wrap || !img || !dot) return;
    if (!devMode || !devSelected) { wrap.style.display = "none"; return; }
    var f = FLOWERS[devSelected.key];
    if (!f || !f.assetUrl) { wrap.style.display = "none"; return; }
    wrap.style.display = "grid";
    if (nameEl) nameEl.textContent = f.name || devSelected.flowerKey;
    if (img.getAttribute("src") !== f.assetUrl) img.src = f.assetUrl;
    var a = (R && R.getFlowerAnchor && R.getFlowerAnchor(devSelected.flowerKey)) ||
            { x: (typeof f.anchorX === "number" ? f.anchorX : 0.5), y: (typeof f.anchorY === "number" ? f.anchorY : 0.5) };
    dot.style.left = (a.x * 100) + "%";
    dot.style.top = (a.y * 100) + "%";
  }

  (function () {
    var wrap = document.getElementById("fb-dev-center");
    var img = document.getElementById("fb-dev-center-img");
    var dot = document.getElementById("fb-dev-center-dot");
    if (!wrap || !img) return;
    img.addEventListener("click", function (e) {
      if (!devSelected || !R || !R.setFlowerAnchor) return;
      var rect = img.getBoundingClientRect();
      var fx = Math.max(0, Math.min(1, (e.clientX - rect.left) / rect.width));
      var fy = Math.max(0, Math.min(1, (e.clientY - rect.top) / rect.height));
      R.setFlowerAnchor(devSelected.flowerKey, fx, fy);
      if (dot) { dot.style.left = (fx * 100) + "%"; dot.style.top = (fy * 100) + "%"; }
      refreshDevJson();
      scheduleRender();
    });
  })();

  var devModeCk = document.getElementById("fb-dev-mode");
  var devSelectedEl = document.getElementById("fb-dev-selected");
  var devCopyBtn = document.getElementById("fb-dev-copy");
  var devSaveSnapshotBtn = document.getElementById("fb-dev-save-snapshot");
  var devLoadSnapshotBtn = document.getElementById("fb-dev-load-snapshot");
  var devCopySnapshotBtn = document.getElementById("fb-dev-copy-snapshot");
  var devDownloadSnapshotBtn = document.getElementById("fb-dev-download-snapshot");
  var devSnapshotStatusEl = document.getElementById("fb-dev-snapshot-status");
  var devResetBtn = document.getElementById("fb-dev-reset");
  var devJsonEl = document.getElementById("fb-dev-json");
  var devGscaleEl = document.getElementById("fb-dev-gscale");
  var devGscaleValEl = document.getElementById("fb-dev-gscale-val");
  var canvasWrapEl = canvas ? canvas.closest(".fb-canvas-wrap") : null;

  // THEME EDITOR ONLY: keep the in-progress bouquet across section re-renders. Every
  // setting change (background zoom, anchor sliders, ...) replaces the section DOM and
  // would otherwise drop all picked flowers -- making it impossible to SEE the effect
  // of the adjustment you just made. Customers on the storefront are unaffected.
  var DESIGN_MODE = !!(window.Shopify && window.Shopify.designMode);
  var DEV_STATE_KEY = "fb-dev-state";
  function saveDevState() {
    if (!DESIGN_MODE) return;
    try {
      sessionStorage.setItem(DEV_STATE_KEY, JSON.stringify({
        people: people,
        size: getSelectedSize(), bgKey: SELECTED_BG_KEY,
        headline: headlineValue(),
        lang: POSTER_LANG,
        snapStyles: Object.keys(loadedSnapshotByStyle),
        devOn: !!(devModeCk && devModeCk.checked)
      }));
    } catch (e) {}
  }
  function restoreDevState() {
    if (!DESIGN_MODE) return;
    try {
      var s = JSON.parse(sessionStorage.getItem(DEV_STATE_KEY) || "null");
      if (!s) return;
      var valid = function (f) { return f && FLOWERS[f.key]; };
      if (Array.isArray(s.people)) people = s.people.filter(valid);
      // Legacy backup shape from the Parents/Children era: concat in list order.
      else if (Array.isArray(s.parents) || Array.isArray(s.children)) {
        people = [].concat(s.parents || [], s.children || []).filter(valid).slice(0, MAX_PEOPLE);
      }
      if (s.size) { var r = document.querySelector('input[name="fb-size"][value="' + s.size + '"]'); if (r) r.checked = true; }
      if (s.headline) { var hEl = document.getElementById("fb-headline"); if (hEl) hEl.value = s.headline; }
      if (s.lang === "en" || s.lang === "sv") POSTER_LANG = s.lang;
      if (s.bgKey === "") { SELECTED_BG_KEY = ""; BG_URL = ""; }
      else if (s.bgKey) {
        var bg = BG_LIST.find(function (b) { return String(b.key || b.id || "") === s.bgKey; });
        if (bg) { SELECTED_BG_KEY = s.bgKey; BG_URL = bg.imageUrl || ""; }
      }
      if (s.devOn && devModeCk) {
        devModeCk.checked = true;
        devMode = true;
        if (canvasWrapEl) canvasWrapEl.classList.add("fb-dev-active");
      }
      // Loaded snapshots survive editor re-renders, per style (legacy snapOn maps
      // to the restored style so an in-flight session isn't dropped).
      var snapStyles = Array.isArray(s.snapStyles) ? s.snapStyles : (s.snapOn ? [SELECTED_BG_KEY || "minimal"] : []);
      snapStyles.forEach(function (sk) {
        try {
          var snap = JSON.parse(localStorage.getItem(SNAPSHOT_KEY + "::" + sk) || localStorage.getItem(SNAPSHOT_KEY) || "null");
          if (snap && snap.adjustments && Object.keys(snap.adjustments).length) loadedSnapshotByStyle[sk] = snap.adjustments;
        } catch (e2) {}
      });
    } catch (e) {}
  }

  if (devGscaleEl) {
    devGscaleEl.value = globalScale;
    if (devGscaleValEl) devGscaleValEl.textContent = globalScale.toFixed(2);
    devGscaleEl.addEventListener("input", function () {
      globalScale = parseFloat(devGscaleEl.value) || 1;
      if (devGscaleValEl) devGscaleValEl.textContent = globalScale.toFixed(2);
      refreshDevJson();
      scheduleRender();
    });
  }

  // Stem-cutoff slider: live px override for the CURRENTLY selected bouquet design.
  // Persists via that background block's "Stem cutoff (px)" setting (type the dialed-in
  // px there), NOT via the adjustments JSON. Switching design resets to its own value.
  var devCutoffEl = document.getElementById("fb-dev-cutoff");
  var devCutoffValEl = document.getElementById("fb-dev-cutoff-val");
  function syncDevCutoff() {
    if (!devCutoffEl) return;
    var px = currentStemCutoff();
    devCutoffEl.value = px;
    if (devCutoffValEl) devCutoffValEl.textContent = Math.round(px) + "px";
  }
  if (devCutoffEl) {
    syncDevCutoff();
    devCutoffEl.addEventListener("input", function () {
      stemCutoffOverride = parseFloat(devCutoffEl.value) || 0;
      if (devCutoffValEl) devCutoffValEl.textContent = Math.round(stemCutoffOverride) + "px";
      scheduleRender();
    });
  }

  // Rect margin sliders: move/resize the colored artboard within the poster. Fractions
  // (top/footer of design height, side of design width). Persist in the adjustments JSON
  // under "margins" via R.setMargins/getMargins; ship with orders as part of _layout metadata.
  var MARGIN_SLIDERS = [
    { key: "top", el: "fb-dev-margin-top", val: "fb-dev-margin-top-val" },
    { key: "side", el: "fb-dev-margin-side", val: "fb-dev-margin-side-val" },
    { key: "footerHeight", el: "fb-dev-margin-fh", val: "fb-dev-margin-fh-val" },
    { key: "footerGap", el: "fb-dev-margin-fg", val: "fb-dev-margin-fg-val" }
  ];
  function syncDevMargins() {
    if (!R || !R.getMargins) return;
    var m = R.getMargins();
    MARGIN_SLIDERS.forEach(function (s) {
      var el = document.getElementById(s.el), vEl = document.getElementById(s.val);
      if (el && typeof m[s.key] === "number") { el.value = m[s.key]; if (vEl) vEl.textContent = m[s.key].toFixed(3); }
    });
  }
  syncDevMargins();
  MARGIN_SLIDERS.forEach(function (s) {
    var el = document.getElementById(s.el), vEl = document.getElementById(s.val);
    if (!el) return;
    el.addEventListener("input", function () {
      var v = parseFloat(el.value);
      if (vEl) vEl.textContent = v.toFixed(3);
      if (R && R.setMargins) { var patch = {}; patch[s.key] = v; R.setMargins(patch); }
      refreshDevJson();
      scheduleRender();
    });
  });

  // Per-species default scale (the size sibling of the anchor map): +/- nudges the
  // selected flower TYPE's size at EVERY position; persists in the adjustments JSON
  // under "scales" and ships with orders as _flower_scales_json.
  // OPT-IN (merchant decision 2026-07-04): every position now has a tuned default, so
  // an all-positions resize must be armed explicitly -- it once got hit by accident
  // and cost a re-tuning session. The value turns red while any scale != 1 is active.
  var devFscaleValEl = document.getElementById("fb-dev-fscale-val");
  var devFscaleEnableEl = document.getElementById("fb-dev-fscale-enable");
  function updateDevFscaleVal() {
    if (!devFscaleValEl) return;
    var v = (devSelected && R && R.getFlowerScale) ? R.getFlowerScale(devSelected.flowerKey) : null;
    devFscaleValEl.textContent = v === null ? "–" : v.toFixed(2);
    devFscaleValEl.style.color = (v !== null && Math.abs(v - 1) > 1e-9) ? "#c0332c" : "";
    devFscaleValEl.style.fontWeight = (v !== null && Math.abs(v - 1) > 1e-9) ? "700" : "";
  }
  function nudgeSpeciesScale(dir) {
    if (!devFscaleEnableEl || !devFscaleEnableEl.checked) {
      statusEl.textContent = "Flower default scale is opt-in: tick its checkbox first — it resizes this flower type at ALL positions.";
      statusEl.style.color = "crimson";
      return;
    }
    if (!devSelected || !R || !R.setFlowerScale) {
      statusEl.textContent = "Select a flower first.";
      statusEl.style.color = "crimson";
      return;
    }
    var step = devCoarse ? 0.1 : 0.02;
    var v = R.setFlowerScale(devSelected.flowerKey, R.getFlowerScale(devSelected.flowerKey) + dir * step);
    updateDevFscaleVal();
    statusEl.textContent = "Default scale for " + devSelected.flowerKey + ": " + v.toFixed(2) + " (all positions).";
    statusEl.style.color = "inherit";
    refreshDevJson();
    scheduleRender();
  }
  var devFscaleMinus = document.getElementById("fb-dev-fscale-minus");
  var devFscalePlus = document.getElementById("fb-dev-fscale-plus");
  if (devFscaleMinus) devFscaleMinus.addEventListener("click", function () { nudgeSpeciesScale(-1); });
  if (devFscalePlus) devFscalePlus.addEventListener("click", function () { nudgeSpeciesScale(1); });

  // "Copy this flower's offsets from" dropdown: lists every OTHER layout where the
  // selected flower type has tuned offsets; the button copies them into the current
  // layout for all shared positions (species offsets only -- base data untouched).
  var devOffsetsFromEl = document.getElementById("fb-dev-offsets-from");
  var devOffsetsFromBtn = document.getElementById("fb-dev-offsets-from-btn");
  function updateDevOffsetsFrom() {
    if (!devOffsetsFromEl) return;
    var opts = [];
    if (devSelected && R && R.getAdjustmentsJson) {
      var fl = (R.getAdjustmentsJson().flowers || {})[devSelected.flowerKey] || {};
      var seen = {};
      Object.keys(fl).forEach(function (ok) {
        var k = ok.split(":")[0];
        if (k && k !== devSelected.splitKey && !seen[k]) { seen[k] = true; opts.push(k); }
      });
    }
    var prev = devOffsetsFromEl.value;
    devOffsetsFromEl.innerHTML = opts.length
      ? opts.map(function (k) { return '<option value="' + k + '">' + k + "</option>"; }).join("")
      : '<option value="">(no tuned layouts)</option>';
    if (opts.indexOf(prev) !== -1) devOffsetsFromEl.value = prev;
  }
  if (devOffsetsFromBtn) devOffsetsFromBtn.addEventListener("click", function () {
    if (!R || !R.copyFlowerOffsetsFrom) return;
    if (!devSelected) {
      statusEl.textContent = "Select a flower first.";
      statusEl.style.color = "crimson";
      return;
    }
    var fromKey = devOffsetsFromEl ? devOffsetsFromEl.value : "";
    if (!fromKey) {
      statusEl.textContent = "No source layout with " + devSelected.flowerKey + " offsets to copy from.";
      statusEl.style.color = "crimson";
      return;
    }
    var n = R.copyFlowerOffsetsFrom(fromKey, devSelected.splitKey, devSelected.flowerKey);
    refreshDevJson();
    scheduleRender();
    statusEl.textContent = n
      ? ("Copied " + n + " " + devSelected.flowerKey + " offset" + (n === 1 ? "" : "s") + " from " + fromKey + " → " + devSelected.splitKey + " (shared positions). Base layout untouched.")
      : ("Nothing copied — " + fromKey + " and " + devSelected.splitKey + " share no positions with " + devSelected.flowerKey + " offsets.");
    statusEl.style.color = n ? "inherit" : "crimson";
  });

  function updateDevPanel() {
    updateCenterPicker();
    updateDevFscaleVal();
    updateDevOffsetsFrom();
    if (!devSelectedEl) return;
    if (!devSelected) { devSelectedEl.style.display = "none"; return; }
    devSelectedEl.style.display = "block";
    var fname = FLOWERS[devSelected.key]?.name || devSelected.flowerKey || devSelected.key;
    var line = "Selected: " + fname + " @ " + devSelected.splitKey + ":" + devSelected.pos;
    if (R && R.getTemplateJson) {
      var slot = R.getTemplateJson(devSelected.splitKey)[devSelected.tplIndex];
      if (slot) line += " — slot x=" + slot.x.toFixed(3) + ", y=" + slot.y.toFixed(3) + ", scale=" + (slot.scale || 1).toFixed(2) + ", rot=" + (slot.rot || 0).toFixed(2);
    }
    if (R && R.getFlowerOffset) {
      var off = R.getFlowerOffset(devSelected.flowerKey, devSelected.splitKey + ":" + devSelected.pos);
      if (off.dx || off.dy || off.scale !== 1 || off.rot || off.dz) {
        line += " — " + fname + " offset dx=" + off.dx.toFixed(3) + ", dy=" + off.dy.toFixed(3) + ", scale=" + off.scale.toFixed(2) + ", rot=" + (off.rot || 0).toFixed(2) + (off.dz ? ", z=" + off.dz : "");
      }
    }
    line += ". Adjusting: " + (getAdjustMode() === "flower" ? "this flower type only" : "the position slot") +
      " — step: " + (devCoarse ? "COARSE" : "fine") + " (X toggles). Shift+↑/↓ = z-order.";
    devSelectedEl.textContent = line;
  }

  function drawDevSelectionHighlight() {
    if (!devMode || !devSelected || !lastBouquet || !ctx) return;
    var slot = lastBouquet.slots.find(function (s) {
      return s.splitKey === devSelected.splitKey && s.tplIndex === devSelected.tplIndex;
    });
    if (!slot) return;
    ctx.save();
    ctx.strokeStyle = "#c0332c";
    ctx.lineWidth = 2;
    ctx.setLineDash([5, 4]);
    ctx.beginPath();
    ctx.arc(slot.x, slot.y, 95 * (slot.scale || 1) * globalScale, 0, Math.PI * 2);
    ctx.stroke();
    // Crosshair at the exact anchor point -- this is where the flower's defined
    // center sits, i.e. the point the layout position, rotation and flip pivot on.
    ctx.setLineDash([]);
    ctx.lineWidth = 1.5;
    ctx.beginPath();
    ctx.moveTo(slot.x - 12, slot.y); ctx.lineTo(slot.x + 12, slot.y);
    ctx.moveTo(slot.x, slot.y - 12); ctx.lineTo(slot.x, slot.y + 12);
    ctx.stroke();
    ctx.beginPath();
    ctx.arc(slot.x, slot.y, 3, 0, Math.PI * 2);
    ctx.fillStyle = "#c0332c";
    ctx.fill();
    ctx.restore();
  }

  function canvasEventToDesignCoords(e) {
    var rect = canvas.getBoundingClientRect();
    var x = (e.clientX - rect.left) / rect.width * R.DESIGN_W;
    var y = (e.clientY - rect.top) / rect.height * (rect.height / rect.width) * R.DESIGN_W;
    return { x: x, y: y };
  }

  if (devModeCk) devModeCk.addEventListener("change", function () {
    devMode = devModeCk.checked;
    if (canvasWrapEl) canvasWrapEl.classList.toggle("fb-dev-active", devMode);
    if (!devMode) { devSelected = null; updateDevPanel(); }
    syncDevTileHighlight();
    refreshDevJson();
    // Dev mode forces live rendering (so a not-yet-calibrated style can be tuned);
    // leaving it puts an inactive style back on its fixed preview image.
    updatePreviewMode();
    scheduleRender();
  });

  if (canvas) canvas.addEventListener("click", function (e) {
    if (!devMode || !lastBouquet || !lastBouquet.slots.length) return;
    var pos = canvasEventToDesignCoords(e);
    var best = null, bestD = 70;
    lastBouquet.slots.forEach(function (s) {
      var d = Math.hypot(pos.x - s.x, pos.y - s.y);
      if (d < bestD) { bestD = d; best = s; }
    });
    devSelected = best ? { splitKey: best.splitKey, tplIndex: best.tplIndex, pos: best.pos, key: best.key, flowerKey: best.flowerKey } : null;
    updateDevPanel();
    syncDevTileHighlight();
    scheduleRender();
  });

  // Re-describe the selection when switching between layout / flower-type adjusting
  Array.prototype.forEach.call(document.querySelectorAll('input[name="fb-dev-adjmode"]'), function (r) {
    r.addEventListener("change", updateDevPanel);
  });

  function onDevKeydown(e) {
    if (!devMode || !R) return;
    var tag = (document.activeElement && document.activeElement.tagName) || "";
    if (tag === "INPUT" || tag === "SELECT" || tag === "TEXTAREA") return;

    // Esc exits the zoom lightbox
    if (e.key === "Escape") {
      exitDevZoom();
      return;
    }

    // X toggles Fine/Coarse step size (works even with nothing selected)
    if (e.key === "x" || e.key === "X") {
      e.preventDefault();
      setCoarse(!devCoarse);
      return;
    }
    if (!devSelected) return;

    var flowerMode = getAdjustMode() === "flower";
    var offsetKey = devSelected.splitKey + ":" + devSelected.pos;
    var big = devCoarse || e.shiftKey; // Shift still works outside the theme editor

    // Shift + Up/Down = manual DRAW ORDER (z): bring the selected flower forward / send it
    // back, overriding the height-based paint order WITHOUT moving it. Stored as offset dz
    // (persists in the adjustments JSON + rides to the admin renderer like every other tweak).
    // Big-step vertical MOVE is still available via Coarse mode (press X).
    if (e.shiftKey && (e.key === "ArrowUp" || e.key === "ArrowDown")) {
      e.preventDefault();
      if (R.nudgeFlowerOffset) R.nudgeFlowerOffset(devSelected.flowerKey, offsetKey, 0, 0, 0, 0, e.key === "ArrowUp" ? 1 : -1);
      refreshDevJson();
      scheduleRender();
      if (typeof updateDevPanel === "function") updateDevPanel();
      return;
    }

    var dir = { ArrowUp: [0, -1], ArrowDown: [0, 1], ArrowLeft: [-1, 0], ArrowRight: [1, 0] }[e.key];
    if (dir) {
      e.preventDefault();
      var step = big ? 0.02 : 0.004;
      if (flowerMode && R.nudgeFlowerOffset) {
        R.nudgeFlowerOffset(devSelected.flowerKey, offsetKey, dir[0] * step, dir[1] * step, 0);
      } else if (R.nudgeSlot) {
        R.nudgeSlot(devSelected.splitKey, devSelected.tplIndex, dir[0] * step, dir[1] * step);
      }
      refreshDevJson();
      scheduleRender();
      return;
    }

    // + / - grow or shrink the selected flower. Key sets cover both US and Swedish
    // layouts: sv Shift+plus types "?", US Shift+equals types "+", etc. Holding the
    // key also auto-repeats, so many small steps work without Shift.
    var dScale = 0;
    if (e.key === "+" || e.key === "=" || e.key === "?") dScale = big ? 0.08 : 0.02;
    else if (e.key === "-" || e.key === "_") dScale = big ? -0.08 : -0.02;
    if (dScale) {
      e.preventDefault();
      if (flowerMode && R.nudgeFlowerOffset) {
        R.nudgeFlowerOffset(devSelected.flowerKey, offsetKey, 0, 0, dScale);
      } else if (R.nudgeSlotScale) {
        R.nudgeSlotScale(devSelected.splitKey, devSelected.tplIndex, dScale);
      }
      refreshDevJson();
      scheduleRender();
      return;
    }

    // , / . rotate the selected flower left/right (Shift = bigger step).
    // "<"/">" = US shifted; ";"/":" = Swedish shifted comma/period.
    var dRot = 0;
    if (e.key === "," || e.key === "<" || e.key === ";") dRot = big ? -0.08 : -0.02;
    else if (e.key === "." || e.key === ">" || e.key === ":") dRot = big ? 0.08 : 0.02;
    if (dRot) {
      e.preventDefault();
      if (flowerMode && R.nudgeFlowerOffset) {
        R.nudgeFlowerOffset(devSelected.flowerKey, offsetKey, 0, 0, 0, dRot);
      } else if (R.nudgeSlotRot) {
        R.nudgeSlotRot(devSelected.splitKey, devSelected.tplIndex, dRot);
      }
      refreshDevJson();
      scheduleRender();
    }
  }
  window.addEventListener("keydown", onDevKeydown);

  // The complete adjustments blob: every count baseline, split layout, and per-species
  // offset touched this session (or loaded from a saved override) -- so tuning one
  // combination after another accumulates into a single copyable JSON.
  function buildCompleteDevJson() {
    var out = (R && R.getAdjustmentsJson) ? R.getAdjustmentsJson() : {};
    var baseGs = (R && R.DEFAULT_GLOBAL_SCALE) || 1;
    if (globalScale !== baseGs) out.globalScale = globalScale;
    // Label the export with the style it was tuned on, so a pasted blob is
    // self-identifying ("which bouquet do I bake this into?"). Underscore keys
    // are ignored by setTemplateOverrides, so old workflows are unaffected.
    var st = selectedStyle();
    out._style = SELECTED_BG_KEY || "minimal";
    out._styleName = st.name || (SELECTED_BG_KEY ? SELECTED_BG_KEY : "Minimal");
    out._exportedAt = new Date().toISOString();
    out._version = String((R && R.VERSION) || "");
    return out;
  }

  function refreshDevJson() {
    if (!devJsonEl) return;
    var out = buildCompleteDevJson();
    // Safety net: mirror the adjustments into sessionStorage on every change, so a
    // section re-render or accidental reload can't lose the tuning session. Restored
    // at boot. Mirrored to localStorage too so even a CLOSED tab (crash) is
    // recoverable. We also record what the SETTING contained at backup time -- if
    // the setting changes later, the backup is stale and gets PARKED at boot
    // (localStorage "fb-dev-adjustments-stale") instead of applied or deleted.
    try {
      var basedon = document.getElementById("fb-position-overrides")?.textContent || "";
      var blob = JSON.stringify(out);
      var bver = String((R && R.VERSION) || ""); // bake detector: backups die with the renderer version they were tuned against
      // PER-STYLE backup slot: each style's session lives under its own key, so
      // switching styles never overwrites another style's in-progress tuning.
      var wSlot = "fb-dev-adjustments::" + (out._style || SELECTED_BG_KEY || "minimal");
      sessionStorage.setItem(wSlot, blob);
      sessionStorage.setItem(wSlot + "-basedon", basedon);
      sessionStorage.setItem(wSlot + "-version", bver);
      localStorage.setItem(wSlot, blob);
      localStorage.setItem(wSlot + "-basedon", basedon);
      localStorage.setItem(wSlot + "-version", bver);
    } catch (e) {}
    if (!devMode) { devJsonEl.style.display = "none"; return; }
    devJsonEl.style.display = "block";
    devJsonEl.value = Object.keys(out).length
      ? JSON.stringify(out, null, 2)
      : "No adjustments yet - nudge a flower (arrows / + / -) or move the scale slider.";
  }

  if (devCopyBtn) devCopyBtn.addEventListener("click", function () {
    if (!R || !R.getAdjustmentsJson) return;
    var out = buildCompleteDevJson();
    if (!Object.keys(out).length) {
      statusEl.textContent = "No adjustments to copy yet.";
      statusEl.style.color = "crimson";
      return;
    }
    refreshDevJson();
    devJsonEl.focus();
    devJsonEl.select();
    try { navigator.clipboard.writeText(devJsonEl.value); } catch (e) {}
    statusEl.textContent = "Complete adjustments JSON copied.";
    statusEl.style.color = "inherit";
  });

  // Manual snapshot: a SEPARATE localStorage key that nothing else ever writes to or
  // clears -- unlike "fb-dev-adjustments" (mirrored on every change, and dropped if the
  // section's Position overrides setting looks stale on reload), this only changes when
  // you click Save, so it survives reloads, stale-backup parking, and section re-renders.
  var SNAPSHOT_KEY = "fb-dev-adjustments-snapshot";

  // PER-STYLE snapshot slot ("...-snapshot::original" / "::minimal" ...), with a
  // read-only fallback to the legacy shared slot when its blob belongs to (or
  // predates) the current style -- so nothing saved before this change is lost.
  function snapshotSlotKey() { return SNAPSHOT_KEY + "::" + (SELECTED_BG_KEY || "minimal"); }
  function readSavedSnapshot() {
    try {
      var s = JSON.parse(localStorage.getItem(snapshotSlotKey()) || "null");
      if (s && s.adjustments) return s;
      var legacy = JSON.parse(localStorage.getItem(SNAPSHOT_KEY) || "null");
      if (legacy && legacy.adjustments) {
        var ls = legacy.adjustments._style;
        if (!ls || ls === (SELECTED_BG_KEY || "minimal")) return legacy;
      }
    } catch (e) {}
    return null;
  }

  function refreshSnapshotStatus() {
    if (!devSnapshotStatusEl) return;
    try {
      var saved = readSavedSnapshot();
      var styleLabel = SELECTED_BG_KEY || "minimal";
      devSnapshotStatusEl.textContent = saved
        ? "Snapshot for '" + styleLabel + "' saved " + (saved.savedAt || "earlier") + "."
        : "No snapshot saved for '" + styleLabel + "'.";
    } catch (e) { devSnapshotStatusEl.textContent = "No manual snapshot saved."; }
  }
  refreshSnapshotStatus();

  if (devSaveSnapshotBtn) devSaveSnapshotBtn.addEventListener("click", function () {
    if (!R || !R.getAdjustmentsJson) return;
    var out = buildCompleteDevJson();
    if (!Object.keys(out).length) {
      statusEl.textContent = "No adjustments to save yet.";
      statusEl.style.color = "crimson";
      return;
    }
    try {
      localStorage.setItem(snapshotSlotKey(), JSON.stringify({ adjustments: out, savedAt: new Date().toLocaleString() }));
      refreshSnapshotStatus();
      statusEl.textContent = "Snapshot saved – safe from reloads and stale-backup clearing.";
      statusEl.style.color = "inherit";
    } catch (e) {
      statusEl.textContent = "Could not save snapshot (storage full or blocked).";
      statusEl.style.color = "crimson";
    }
  });

  if (devLoadSnapshotBtn) devLoadSnapshotBtn.addEventListener("click", function () {
    if (!R || !R.setTemplateOverrides) return;
    try {
      var saved = readSavedSnapshot();
      if (!saved || !saved.adjustments || !Object.keys(saved.adjustments).length) {
        statusEl.textContent = "No manual snapshot to load.";
        statusEl.style.color = "crimson";
        return;
      }
      R.setTemplateOverrides(saved.adjustments);
      loadedSnapshotByStyle[SELECTED_BG_KEY || "minimal"] = saved.adjustments; // survives style switches / editor re-renders
      saveDevState();
      if (typeof saved.adjustments.globalScale === "number" && saved.adjustments.globalScale > 0) {
        globalScale = saved.adjustments.globalScale;
        if (devGscaleEl) {
          devGscaleEl.value = globalScale;
          if (devGscaleValEl) devGscaleValEl.textContent = globalScale.toFixed(2);
        }
      }
      refreshDevJson();
      scheduleRender();
      statusEl.textContent = "Snapshot loaded (saved " + (saved.savedAt || "earlier") + ").";
      statusEl.style.color = "inherit";
    } catch (e) {
      statusEl.textContent = "Could not load snapshot.";
      statusEl.style.color = "crimson";
    }
  });

  if (devCopySnapshotBtn) devCopySnapshotBtn.addEventListener("click", function () {
    try {
      var saved = readSavedSnapshot();
      if (!saved || !saved.adjustments || !Object.keys(saved.adjustments).length) {
        statusEl.textContent = "No manual snapshot to copy.";
        statusEl.style.color = "crimson";
        return;
      }
      var text = JSON.stringify(saved.adjustments, null, 2);
      if (devJsonEl) {
        devJsonEl.style.display = "block";
        devJsonEl.value = text;
        devJsonEl.focus();
        devJsonEl.select();
      }
      try { navigator.clipboard.writeText(text); } catch (e2) {}
      statusEl.textContent = "Snapshot JSON copied (saved " + (saved.savedAt || "earlier") + ").";
      statusEl.style.color = "inherit";
    } catch (e) {
      statusEl.textContent = "Could not copy snapshot.";
      statusEl.style.color = "crimson";
    }
  });

  if (devDownloadSnapshotBtn) devDownloadSnapshotBtn.addEventListener("click", function () {
    try {
      var saved = readSavedSnapshot();
      if (!saved || !saved.adjustments || !Object.keys(saved.adjustments).length) {
        statusEl.textContent = "No manual snapshot to download.";
        statusEl.style.color = "crimson";
        return;
      }
      var text = JSON.stringify(saved.adjustments, null, 2);
      // Always mirror into the textarea first: the theme-editor preview runs in a
      // sandboxed iframe that blocks programmatic downloads AND clipboard writes, so
      // this guarantees a manual select+copy fallback even when a.click() no-ops.
      if (devJsonEl) { devJsonEl.style.display = "block"; devJsonEl.value = text; devJsonEl.focus(); devJsonEl.select(); }
      var blob = new Blob([text], { type: "application/json" });
      var url = URL.createObjectURL(blob);
      var a = document.createElement("a");
      a.href = url;
      // Put the STYLE in the filename so multiple downloads (minimal / a background)
      // are easy to tell apart; the JSON also self-labels via _style.
      var dlStyle = (saved.adjustments && saved.adjustments._style) || SELECTED_BG_KEY || "minimal";
      a.download = "flower-bouquet-" + dlStyle + "-" + Date.now() + ".json";
      document.body.appendChild(a);
      a.click();
      a.remove();
      setTimeout(function () { URL.revokeObjectURL(url); }, 1000);
      statusEl.textContent = "Snapshot in the box below (Ctrl+C to copy). A download may also start — blocked inside the theme editor; use the live URL for a real file.";
      statusEl.style.color = "inherit";
    } catch (e) {
      statusEl.textContent = "Could not download snapshot.";
      statusEl.style.color = "crimson";
    }
  });

  if (devResetBtn) devResetBtn.addEventListener("click", function () {
    if (!R || !R.resetTemplate) return;
    if (!devSelected) {
      statusEl.textContent = "Select a flower first (click one on the preview or a Parents/Children tile).";
      statusEl.style.color = "crimson";
      return;
    }
    R.resetTemplate(devSelected.splitKey);
    refreshDevJson();
    scheduleRender();
    statusEl.textContent = "Layout " + devSelected.splitKey + " reset to baseline.";
    statusEl.style.color = "inherit";
  });

  // "Start over on THIS style": clears the whole unsaved tuning session (species
  // offsets, anchors, scales, margins, layout edits) and rebuilds the style from
  // its released state (baked baseline -> baked style entry -> settings). The
  // previous session is PARKED, never deleted. Two-click arm pattern per the
  // house rule for session-destroying actions (an accidental click once cost a
  // re-tuning session) -- works everywhere, unlike confirm() in the editor iframe.
  var devResetStyleBtn = document.getElementById("fb-dev-reset-style");
  var _resetStyleArmedAt = 0;
  if (devResetStyleBtn) devResetStyleBtn.addEventListener("click", function () {
    var now = Date.now();
    if (now - _resetStyleArmedAt > 5000) {
      _resetStyleArmedAt = now;
      statusEl.textContent = "Click again within 5 s to clear ALL unsaved tuning for this style. A copy is parked first (recoverable).";
      statusEl.style.color = "crimson";
      return;
    }
    _resetStyleArmedAt = 0;
    try {
      var rSlot = "fb-dev-adjustments::" + (SELECTED_BG_KEY || "minimal");
      var prevBlob = sessionStorage.getItem(rSlot) || localStorage.getItem(rSlot) || sessionStorage.getItem("fb-dev-adjustments") || localStorage.getItem("fb-dev-adjustments");
      if (prevBlob) localStorage.setItem("fb-dev-adjustments-stale::" + (SELECTED_BG_KEY || "minimal"), prevBlob);
      [rSlot, rSlot + "-basedon", rSlot + "-version", "fb-dev-adjustments", "fb-dev-adjustments-basedon", "fb-dev-adjustments-version"].forEach(function (k) {
        sessionStorage.removeItem(k); localStorage.removeItem(k);
      });
    } catch (e) {}
    delete loadedSnapshotByStyle[SELECTED_BG_KEY || "minimal"]; // the loaded snapshot is part of the session being discarded
    delete _backupAppliedForStyle[SELECTED_BG_KEY || "minimal"];
    // The saved snapshot would auto-load right back -- park it too (recoverable at
    // "<snapshot key>-discarded"); same for a legacy shared snapshot owned by this style.
    try {
      var snapBlob = localStorage.getItem(snapshotSlotKey());
      if (snapBlob) { localStorage.setItem(snapshotSlotKey() + "-discarded", snapBlob); localStorage.removeItem(snapshotSlotKey()); }
      var legacySnapRaw = localStorage.getItem(SNAPSHOT_KEY);
      if (legacySnapRaw) {
        var legacySnap = JSON.parse(legacySnapRaw);
        var lss = legacySnap && legacySnap.adjustments && legacySnap.adjustments._style;
        if (!lss || lss === (SELECTED_BG_KEY || "minimal")) {
          localStorage.setItem(snapshotSlotKey() + "-discarded", legacySnapRaw);
          localStorage.removeItem(SNAPSHOT_KEY);
        }
      }
    } catch (eSnap) {}
    stemCutoffOverride = null;
    applyStyleAdjustments();
    if (typeof syncDevCutoff === "function") syncDevCutoff();
    if (typeof syncDevMargins === "function") syncDevMargins();
    refreshDevJson();
    scheduleRender();
    statusEl.textContent = "Style reset to its released state. Previous tuning parked at localStorage 'fb-dev-adjustments-stale'.";
    statusEl.style.color = "inherit";
  });

  // Canvas zoom (viewing aid only -- never affects the render data). Lightbox mode:
  // the canvas wrap is MOVED into a fixed overlay above everything; the backdrop
  // scrolls to pan. Selection/nudging keep working because hit-testing derives from
  // the live element size. Exit: zoom back to 1, click the backdrop, or press Esc.
  var devZoomEl = document.getElementById("fb-dev-zoom");
  var devZoomValEl = document.getElementById("fb-dev-zoom-val");
  var devZoomOverlay = document.getElementById("fb-dev-zoom-overlay");
  var canvasWrapHome = canvasWrapEl ? canvasWrapEl.parentElement : null;

  function applyDevZoom(z) {
    if (!canvasWrapEl || !devZoomOverlay || !canvasWrapHome) return;
    if (devZoomValEl) devZoomValEl.textContent = z.toFixed(2);
    if (z > 1) {
      if (canvasWrapEl.parentElement !== devZoomOverlay) devZoomOverlay.appendChild(canvasWrapEl);
      devZoomOverlay.style.display = "block";
      canvasWrapEl.style.width = Math.min(96, z * 32) + "vw";
    } else {
      devZoomOverlay.style.display = "none";
      if (canvasWrapEl.parentElement !== canvasWrapHome) canvasWrapHome.insertBefore(canvasWrapEl, canvasWrapHome.firstChild);
      canvasWrapEl.style.width = "";
    }
    scheduleRender(); // re-render at the new backing size so it stays crisp
  }

  function exitDevZoom() {
    if (devZoomEl) devZoomEl.value = 1;
    applyDevZoom(1);
  }

  if (devZoomEl) devZoomEl.addEventListener("input", function () {
    applyDevZoom(parseFloat(devZoomEl.value) || 1);
  });
  if (devZoomOverlay) devZoomOverlay.addEventListener("click", function (e) {
    if (e.target === devZoomOverlay) exitDevZoom();
  });

  // Copy the current split's tuned layout to the split with one more child
  // (p2c1 -> p2c2 etc.), matched by position id. The extra child keeps its default.
  var devCopyNextBtn = document.getElementById("fb-dev-copy-next");
  if (devCopyNextBtn) devCopyNextBtn.addEventListener("click", function () {
    if (!R || !R.copySplitTo) return;
    if (!devSelected) {
      statusEl.textContent = "Select a flower first so I know which layout to copy.";
      statusEl.style.color = "crimson";
      return;
    }
    var m = /^p(\d+)c(\d+)$/.exec(devSelected.splitKey);
    if (!m) return;
    var p = parseInt(m[1], 10), c = parseInt(m[2], 10);
    if (c >= 10) {
      statusEl.textContent = "Already at the maximum number of children.";
      statusEl.style.color = "crimson";
      return;
    }
    var toKey = "p" + p + "c" + (c + 1);
    R.copySplitTo(devSelected.splitKey, toKey);
    refreshDevJson();
    scheduleRender();
    statusEl.textContent = "Copied " + devSelected.splitKey + " → " + toKey + ". Add one more child to see it.";
    statusEl.style.color = "inherit";
  });

  // Copy ONLY the selected flower type's offset (e.g. the april {} entry) at this
  // position to the same position in the +1-child split. The target's slot layout
  // (BASE data) is deliberately left untouched -- copying slots would write new base
  // overrides into the JSON and dirty the baked baseline.
  var devCopySlotNextBtn = document.getElementById("fb-dev-copy-slot-next");
  if (devCopySlotNextBtn) devCopySlotNextBtn.addEventListener("click", function () {
    if (!R || !R.copyFlowerOffsetTo) return;
    if (!devSelected) {
      statusEl.textContent = "Select a flower first.";
      statusEl.style.color = "crimson";
      return;
    }
    var m = /^p(\d+)c(\d+)$/.exec(devSelected.splitKey);
    if (!m) return;
    var p = parseInt(m[1], 10), c = parseInt(m[2], 10);
    if (c >= 10) {
      statusEl.textContent = "Already at the maximum number of children.";
      statusEl.style.color = "crimson";
      return;
    }
    var toKey = "p" + p + "c" + (c + 1);
    var ok = R.copyFlowerOffsetTo(devSelected.splitKey, toKey, devSelected.pos, devSelected.flowerKey);
    refreshDevJson();
    scheduleRender();
    statusEl.textContent = ok
      ? ("Copied " + devSelected.flowerKey + " offset at " + devSelected.pos + " (" + devSelected.splitKey + " → " + toKey + "). Base layout untouched.")
      : ("No " + devSelected.flowerKey + " offset at this position to copy.");
    statusEl.style.color = ok ? "inherit" : "crimson";
  });

  var devClearOffsetBtn = document.getElementById("fb-dev-clear-offset");
  if (devClearOffsetBtn) devClearOffsetBtn.addEventListener("click", function () {
    if (!devSelected || !R || !R.clearFlowerOffset) {
      statusEl.textContent = "Select a flower first.";
      statusEl.style.color = "crimson";
      return;
    }
    R.clearFlowerOffset(devSelected.flowerKey, devSelected.splitKey + ":" + devSelected.pos);
    refreshDevJson();
    scheduleRender();
    statusEl.textContent = "";
  });


  function scheduleTextRender() {
    clearTimeout(textTimer);
    textTimer = setTimeout(() => {
      if (!styleIsLive()) { saveDevState(); return; } // static style: fixed image, no canvas
      var v = validate();
      statusEl.textContent = v.ok ? "" : v.msg;
      statusEl.style.color = v.ok ? "inherit" : "crimson";
      // Render regardless -- an empty bouquet still shows the board + background.
      renderPreview();
      saveDevState();
    }, 120);
  }

  // Check if all current flowers are already cached
  function allImagesCached() {
    if (BG_URL) {
      var bimg = IMG_CACHE[BG_KEY];
      if (!bimg || !bimg.complete || !bimg.naturalWidth) return false;
    }
    if (TEXTURE_URL) {
      var timg = IMG_CACHE[TEXTURE_KEY];
      if (!timg || !timg.complete || !timg.naturalWidth) return false;
    }
    if (SELECTED_BG_KEY === "" && NEUTRAL_LEAF) {
      var limg = IMG_CACHE[LEAF_KEY];
      if (!limg || !limg.complete || !limg.naturalWidth) return false;
    }
    var keys = [...new Set(people.map(f => f.key))];
    for (var i = 0; i < keys.length; i++) {
      var k = String(keys[i] || "");
      var url = FLOWERS[k]?.assetUrl;
      if (!url) continue;
      var img = IMG_CACHE[k];
      if (!img || !img.complete || !img.naturalWidth) return false;
      if (FLOWERS[k]?.stemUrl) {
        var simg = IMG_CACHE["stem:" + k];
        if (!simg || !simg.complete || !simg.naturalWidth) return false;
      }
    }
    return true;
  }

  function scheduleRender() {
    clearTimeout(renderTimer);
    clearTimeout(textTimer);
    renderTimer = setTimeout(async () => {
      if (!styleIsLive()) { hideLoader(); saveDevState(); return; } // static style: fixed image, no canvas
      var v = validate();
      statusEl.textContent = v.ok ? "" : v.msg;
      statusEl.style.color = v.ok ? "inherit" : "crimson";

      // Render even when invalid (e.g. no flowers picked yet) so the customer
      // immediately sees the board with its background design.
      try {
        // Load any missing flower images SILENTLY while the customer builds -- no
        // overlay on add/reorder. The loader is reserved for exports + add-to-cart
        // (doExport / add handler). The initial page-load overlay is rendered by
        // Liquid and cleared by the hideLoader() below on the first render.
        if (!allImagesCached()) {
          await ensureAllLoaded();
        }
        renderPreview();
        hideLoader();
        saveDevState();
      } catch (e) {
        console.warn("[FB] Render error:", e);
        statusEl.textContent = t("render_error", "Render error \u2013 please try again.");
        statusEl.style.color = "crimson";
        hideLoader();
      }
    }, 60);
  }

  // ============================================================
  // K) DOWNLOADS
  // ============================================================
  // format: "jpg" | "png" | "pdf". opts.bleedMm (pdf only) = bleed per side in mm (0 = none).
  // Bleed as a parameter keeps one code path and makes new bleed presets a one-line handler.
  async function doExport(format, opts) {
    opts = opts || {};
    if (!styleIsLive()) return; // static style: no real render to export (buttons are hidden anyway)
    var v = validate();
    if (!v.ok) { statusEl.textContent = v.msg; statusEl.style.color = "crimson"; return; }
    if (!R) { statusEl.textContent = "Renderer not loaded."; statusEl.style.color = "crimson"; return; }
    showLoader("Exporting\u2026");
    try {
      await ensureAllLoaded();
      // Fonts too: an export fired before document.fonts settles would silently fall
      // back to Rockwell on the names line (audit 2026-07-17).
      try { if (R.ensureFontLoaded) await R.ensureFontLoaded(getStyle()); } catch (eF) {}
      var size = getSelectedSize();
      var longSide = R.calcPrintLongSide(size, 300);
      var names = getAllFlowers().map(f => R.safeFilename(personName(f))).filter(Boolean).join("-") || "bouquet";

      if (format === "png") {
        var pngUrl = await R.exportPng({ input: getInput(), imagesByKey: imagesByKey(), style: getStyle(), longSide: longSide, sizeKey: size });
        R.downloadDataUrl(pngUrl, "PRINT-" + names + "-" + size + "-300dpi.png");
      } else if (format === "pdf") {
        if (!window.jspdf || !window.jspdf.jsPDF) { statusEl.textContent = "PDF library still loading – try again in a moment."; statusEl.style.color = "crimson"; return; }
        var bleedMm = (typeof opts.bleedMm === "number" && opts.bleedMm >= 0) ? opts.bleedMm : 4;
        var pdfBlob = await R.exportPdf({ input: getInput(), imagesByKey: imagesByKey(), style: getStyle(), size: size, dpi: 300, bleedMm: bleedMm });
        var pdfName = "PRINT-" + names + "-" + size + "-300dpi" + (bleedMm > 0 ? "-" + bleedMm + "mmbleed" : "-nobleed") + ".pdf";
        var pdfHref = URL.createObjectURL(pdfBlob);
        var pdfA = document.createElement("a");
        pdfA.href = pdfHref; pdfA.download = pdfName;
        document.body.appendChild(pdfA); pdfA.click(); document.body.removeChild(pdfA);
        setTimeout(function () { URL.revokeObjectURL(pdfHref); }, 60000);
      } else {
        var jpgUrl = await R.exportJpg({ input: getInput(), imagesByKey: imagesByKey(), style: getStyle(), longSide: longSide, quality: 0.92, sizeKey: size });
        R.downloadDataUrl(jpgUrl, "PRINT-" + names + "-" + size + "-300dpi.jpg");
      }
    } finally { hideLoader(); }
  }

  if (dlJpgBtn) dlJpgBtn.addEventListener("click", () => doExport("jpg"));
  if (dlPngBtn) dlPngBtn.addEventListener("click", () => doExport("png"));
  if (dlPdfBtn) dlPdfBtn.addEventListener("click", () => doExport("pdf", { bleedMm: 4 }));
  if (dlPdfNoBleedBtn) dlPdfNoBleedBtn.addEventListener("click", () => doExport("pdf", { bleedMm: 0 }));

  // ============================================================
  // L) ADD TO CART
  // ============================================================
  if (addToCartBtn) {
    addToCartBtn.addEventListener("click", async () => {
      if (!styleIsLive()) { // static style: what's shown is a fixed example, not this order
        statusEl.textContent = t("coming_soon", "This design is coming soon – it can't be ordered yet.");
        statusEl.style.color = "crimson";
        return;
      }
      var v = validate();
      if (!v.ok) { statusEl.textContent = v.msg; statusEl.style.color = "crimson"; return; }

      showLoader(t("adding_to_cart", "Adding to cart\u2026"));
      try {
        var allF = getAllFlowers();
        var flowerSummary = allF.map(f => (personName(f) || flowerDisplayName(f.key) || "?")).join(", ");
        var size = getSelectedSize();

        // Build flower data as JSON string for line item
        var flowerData = allF.map((f, i) => ({
          slot: i < 2 ? "parent" : "child",
          key: f.key,
          flowerKey: FLOWERS[f.key]?.flowerKey || f.key,
          flowerName: posterFlowerName(f.key) || "", // what the poster's flowers line prints
          cardLabel: flowerDisplayName(f.key) || "", // the month label the customer picked by
          assetUrl: FLOWERS[f.key]?.assetUrl || "",
          stemUrl: FLOWERS[f.key]?.stemUrl || "",
          cmFactor: f.cmFactor || FLOWERS[f.key]?.cmFactor || "1.0",
          direction: f.direction || FLOWERS[f.key]?.direction || "right",
          shapeRole: f.shapeRole || FLOWERS[f.key]?.shapeRole || "feature",
          name: personName(f)
        }));

        // Layout snapshot so admin-poster-review can re-render this exact poster:
        // which split template was used (p<parents>c<children>), the tuned slot positions
        // active at order time, and any per-species offsets that apply to this split.
        var pCount = Math.min(allF.length, 2);
        var cCount = Math.max(allF.length - 2, 0);
        var layoutKey = (R && R.splitKeyFor) ? R.splitKeyFor(pCount, cCount) : ("p" + pCount + "c" + cCount);
        var layoutJson = (R && R.getTemplateJson) ? JSON.stringify(R.getTemplateJson(layoutKey)) : "";
        var flowerOffsets = {};
        var flowerAnchors = {};
        var flowerScales = {};
        if (R && R.getAdjustmentsJson) {
          var adj = R.getAdjustmentsJson();
          if (adj.flowers) {
            Object.keys(adj.flowers).forEach(function (fk) {
              Object.keys(adj.flowers[fk]).forEach(function (ok) {
                if (ok.indexOf(layoutKey + ":") === 0) {
                  (flowerOffsets[fk] = flowerOffsets[fk] || {})[ok] = adj.flowers[fk][ok];
                }
              });
            });
          }
          // Ship ALL anchors/scales unfiltered. Filtering by the flowers in THIS order
          // broke on localized storefronts: adj keys are canonical English ("june") but
          // the order's flowerKeys are localized ("juni"), so nothing matched and the
          // metadata shipped empty (audit 2026-07-17). A dozen anchors is tiny anyway.
          if (adj.anchors) flowerAnchors = adj.anchors;
          if (adj.scales) flowerScales = adj.scales;
        }

        var selectedBg = BG_LIST.find(b => String(b.key || b.id || "") === SELECTED_BG_KEY) || null;
        var properties = {
          "_poster_type": "flower-bouquet",
          "_size": size,
          "_headline": headlineValue(),
          "_poster_language": POSTER_LANG,
          "_rect_color": getSelectedRectColor(),
          "_bg_color": "#FFFFFF",
          "_text_color": "#111111",
          "_bg_key": selectedBg ? (selectedBg.key || selectedBg.id || "") : "",
          "_bg_name": selectedBg ? (selectedBg.name || "") : "",
          "_bg_url": selectedBg ? (selectedBg.imageUrl || "") : BG_URL,
          "_flower_count": String(allF.length),
          "_parent_count": String(pCount),
          "_child_count": String(cCount),
          "_flowers_json": JSON.stringify(flowerData),
          "_layout_key": layoutKey,
          "_layout_json": layoutJson,
          "_flower_offsets_json": JSON.stringify(flowerOffsets),
          "_flower_anchors_json": JSON.stringify(flowerAnchors),
          "_flower_scales_json": JSON.stringify(flowerScales),
          "_global_scale": String(globalScale),
          "_stem_cutoff_px": String(Math.round(currentStemCutoff())),
          // Full-fidelity snapshot (audit 2026-07-17): everything the canvas rendered
          // that previously lived only in theme settings -- so reprints stay identical
          // even if the merchant later retunes the section/blocks.
          "_style_key": SELECTED_BG_KEY || "minimal",
          "_no_names": noNames() ? "true" : "",
          "_bg_placement_json": selectedBg ? JSON.stringify({
            anchorX: typeof selectedBg.anchorX === "number" ? selectedBg.anchorX : 0.5,
            anchorY: typeof selectedBg.anchorY === "number" ? selectedBg.anchorY : 0.5,
            scale: typeof selectedBg.scale === "number" ? selectedBg.scale : 1
          }) : "",
          "_leaf_json": (SELECTED_BG_KEY === "" && NEUTRAL_LEAF) ? JSON.stringify({
            url: NEUTRAL_LEAF.url,
            x: Number(NEUTRAL_LEAF.x) || 0.5,
            y: Number(NEUTRAL_LEAF.y) || 0.78,
            scale: Number(NEUTRAL_LEAF.scale) || 0.18,
            rot: Number(NEUTRAL_LEAF.rot) || 0
          }) : "",
          "_texture_json": textureActive() ? JSON.stringify({
            url: TEXTURE_URL,
            opacity: Number(parsed.textureOpacity) || 0.4
          }) : "",
          "_margins_json": (R && R.getMargins) ? JSON.stringify(R.getMargins()) : "",
          "Poster": "Bouquet \u2013 " + flowerSummary + " \u2013 " + size + " cm"
        };

        // Find matching variant by size -- same matcher the price display uses, so cart
        // and shown price can never diverge.
        var variant = findSizeVariant(size) || (PRODUCT_DATA.variants || [])[0];

        if (!variant) {
          throw new Error("No product variant configured.");
        }

        var SECTIONS_PARAM = "cart-notification-product,cart-notification-button,cart-icon-bubble";
        var posterItem = { id: variant.id, quantity: 1, properties: properties, title: PRODUCT_DATA.title || "" };
        var hadFrameSelected = !!((window.TBPFrame && window.TBPFrame.getSelection) ? window.TBPFrame.getSelection() : null);
        var items = (window.TBPFrame && window.TBPFrame.buildItems) ? window.TBPFrame.buildItems(posterItem) : [posterItem];
        var frameUnavailable = hadFrameSelected && items.length < 2;
        var bundled = items.length > 1;

        // Only a real 2-line bundle needs the `items` array request shape. With no frame
        // add-on on the page (product untagged / frames disabled) or no frame selected, send
        // the exact single-item request this page has always sent -- unchanged wire shape.
        var singleBody = { id: variant.id, quantity: 1, properties: properties, sections: SECTIONS_PARAM };

        var resp = await fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json", "Accept": "application/json" },
          body: JSON.stringify(bundled ? { items: items, sections: SECTIONS_PARAM } : singleBody)
        });

        // /cart/add.js with an `items` array is all-or-nothing: if the frame variant sold out
        // between page load and click, the WHOLE request 422s and the customer would lose a
        // poster they may have spent ten minutes building. Retry once with the poster alone --
        // losing the frame is far better than losing the order.
        if (!resp.ok && resp.status === 422 && bundled) {
          resp = await fetch("/cart/add.js", {
            method: "POST",
            headers: { "Content-Type": "application/json", "Accept": "application/json" },
            body: JSON.stringify(singleBody)
          });
          if (resp.ok) frameUnavailable = true;
        }

        if (!resp.ok) {
          var errData = await resp.json().catch(() => ({}));
          throw new Error(errData.description || t("cart_failed", "Could not add to cart."));
        }

        var parsedState = await resp.json();
        // The `items` array response shape has no top-level `key` (only a single-item add
        // gets one) -- CartNotification.renderContents reads parsedState.key to pick which
        // cart-notification-product-<key> row to show, so without this the popup renders
        // empty. Seed it with the poster's key so Dawn's own render resolves to *something*;
        // the frame row is appended separately right below (the customer should see both
        // lines they just added, not just the poster).
        if (parsedState.items && !parsedState.key) {
          var addedPoster = parsedState.items.filter(function (i) {
            return i.properties && i.properties._bundle_role === "poster";
          })[0] || parsedState.items[0];
          if (addedPoster) parsedState.key = addedPoster.key;
        }
        var notification = document.querySelector("cart-notification");
        if (notification && typeof notification.renderContents === "function") {
          notification.renderContents(parsedState);
          // Client requirement: the popup must show BOTH the poster and the frame, STACKED --
          // not side by side. #cart-notification-product's own CSS
          // (component-cart-notification.css's .cart-notification-product) is a single flex
          // ROW meant to hold one item's image beside its text; Dawn's renderContents writes
          // the poster row's innerHTML straight into it (already two flex siblings: image +
          // details), so simply appending a second row's ELEMENT made it a third sibling in
          // that same row -- image, poster text, and frame row side by side. Instead, when a
          // frame is present, discard Dawn's write and rebuild the container from BOTH whole
          // row elements (each keeps its own id + .cart-item class, which resolves to no
          // layout of its own in this popup -- component-cart-items.css only styles it inside
          // the full cart table -- so each row needs its own row-level flex added back).
          // Everything here is best-effort: no frame in the response, missing/malformed
          // sections HTML, or a row not found all leave Dawn's poster-only render untouched --
          // the confirmation the customer already sees must never break for this.
          try {
            var frameItem = parsedState.items && parsedState.items.filter(function (i) {
              return i.properties && i.properties._bundle_role === "frame";
            })[0];
            var productSectionHtml = parsedState.sections && parsedState.sections["cart-notification-product"];
            if (frameItem && frameItem.key && productSectionHtml) {
              var parsedSectionDoc = new DOMParser().parseFromString(productSectionHtml, "text/html");
              var posterRow = parsedSectionDoc.querySelector('[id="cart-notification-product-' + parsedState.key + '"]');
              var frameRow = parsedSectionDoc.querySelector('[id="cart-notification-product-' + frameItem.key + '"]');
              var productContainer = document.getElementById("cart-notification-product");
              if (posterRow && frameRow && productContainer) {
                [posterRow, frameRow].forEach(function (row) {
                  row.style.display = "flex";
                  row.style.alignItems = "flex-start";
                });
                productContainer.style.display = "flex";
                productContainer.style.flexDirection = "column";
                productContainer.style.alignItems = "stretch";
                productContainer.innerHTML = "";
                productContainer.appendChild(posterRow);
                productContainer.appendChild(frameRow);
              }
            }
          } catch (e) { /* poster confirmation already rendered -- never risk it for the frame row */ }
        } else {
          // redesign: the slide-in cart drawer when the theme has one, else the cart page
          if (window.tbOpenCartDrawer) { window.tbOpenCartDrawer(); } else { window.location.href = "/cart"; }
        }

        if (frameUnavailable) {
          statusEl.textContent = t("frame_unavailable", "The frame you picked just sold out – we added your poster without it.");
          statusEl.style.color = "crimson";
        }
      } catch (err) {
        console.error("[FB] Add to cart error:", err);
        statusEl.textContent = err.message || t("something_wrong", "Something went wrong.");
        statusEl.style.color = "crimson";
      } finally {
        hideLoader();
      }
    });
  }

  // ============================================================
  // M) PRICING
  // ============================================================
  // Fill the shop's own money_format string (e.g. amount_no_decimals in moustache braces,
  // then " kr") so a
  // client-computed total (poster + frame, which has no server-rendered priceFormatted of
  // its own) matches the "X kr" style every other price on the page already uses, instead
  // of falling back to a bare ISO code. Returns null if the format has no placeholder we
  // recognize, so the caller can fall back to its own plain rendering.
  function applyMoneyFormat(cents, format) {
    var units = cents / 100;
    var noDecimals = Math.round(units).toString();
    var withDecimals = units.toFixed(2);
    var commaDecimals = withDecimals.replace(".", ",");
    var raw = String(format);
    var substituted = raw
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, noDecimals)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, commaDecimals)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, noDecimals)
      .replace(/\{\{\s*amount\s*\}\}/g, withDecimals);
    if (substituted === raw) return null; // no known placeholder -- let the caller fall back
    return substituted.replace(/<[^>]+>/g, ""); // money_format sometimes wraps in a <span>
  }

  function formatMoney(cents) {
    var applied = PRODUCT_DATA.moneyFormat ? applyMoneyFormat(cents, PRODUCT_DATA.moneyFormat) : null;
    if (applied) return applied;
    return (cents / 100).toFixed(0) + " " + (PRODUCT_DATA.currency || "SEK");
  }

  // Collapse "30x40" / "30\u00d740" / "30 \u00d7 40 cm" to a comparable token so the size the
  // builder tracks matches the variant title however the merchant typed it.
  function normSize(s) { return String(s || "").toLowerCase().replace(/[\u00d7x\s]/g, ""); }
  function findSizeVariant(size) {
    var want = normSize(size);
    if (!want) return undefined;
    var bySize = (PRODUCT_DATA.variants || []).filter(v => v.title && normSize(v.title).indexOf(want) !== -1);
    // The product also has a Design option ("Orginal" / "Minimal"): pick the variant
    // matching the chosen style, or a Minimal poster lands in the cart as the original
    // design. Products without that option still match on size alone.
    var wantMinimal = SELECTED_BG_KEY === "";
    return bySize.find(v => /minimal/i.test(v.title) === wantMinimal) || bySize[0];
  }

  function updateCartPrice() {
    var v = findSizeVariant(getSelectedSize()) || (PRODUCT_DATA.variants || [])[0];
    if (!v) return;
    var nowEl = document.getElementById("fb-price-now");
    var btnPriceEl = document.getElementById("fb-btn-price");
    var formatted = v.priceFormatted || formatMoney(v.price);

    if (nowEl && formatted) nowEl.textContent = formatted;
    // Liquid renders .fb-price-was / .fb-price-save server-side when there's
    // a compare-at price, so no innerHTML rewrite needed here.

    // The CTA total includes the frame add-on (if one is selected) so it shows what the
    // customer will actually be charged. fb-price-now above stays the poster's own price --
    // both catalogs report price in the shop's smallest currency unit, so they sum directly.
    var btnTotal = formatted;
    var frameSel = (window.TBPFrame && window.TBPFrame.getSelection) ? window.TBPFrame.getSelection() : null;
    if (frameSel && typeof frameSel.price === "number" && typeof v.price === "number") {
      btnTotal = formatMoney(v.price + frameSel.price);
    }
    if (btnPriceEl) btnPriceEl.textContent = btnTotal;
    updateSizeNotes();
  }

  // Price + shipping consequence under each size in the picker. Shown at decision
  // time on purpose: 30x40 sits below the free-shipping threshold, and discovering
  // that at checkout -- after ten minutes of building a poster -- was costing orders.
  function updateSizeNotes() {
    var priceEls = document.querySelectorAll(".fb-size__price");
    if (!priceEls.length) return;

    priceEls.forEach(function (priceEl) {
      var v = findSizeVariant(priceEl.getAttribute("data-size"));
      // No matching variant: leave the line empty so the CSS :empty rule collapses
      // it and the button falls back to just the dimensions.
      priceEl.textContent = v ? (v.priceFormatted || formatMoney(v.price)) : "";
    });
  }

  // ============================================================
  // N) EVENTS + INIT
  // ============================================================
  sizeInputs.forEach(r => r.addEventListener("change", () => {
    if (window.TBPFrame && window.TBPFrame.setSize) window.TBPFrame.setSize(getSelectedSize());
    updateCartPrice();
    scheduleRender();
  }));
  var headlineInputEl = document.getElementById("fb-headline");
  if (headlineInputEl) headlineInputEl.addEventListener("input", scheduleTextRender);
  document.querySelectorAll(".fb-lang-btn").forEach(function (b) {
    b.addEventListener("click", function () {
      var lang = b.getAttribute("data-lang") === "en" ? "en" : "sv";
      if (lang === POSTER_LANG) return;
      POSTER_LANG = lang;
      applyLanguage();
      saveDevState();
    });
  });
  window.addEventListener("resize", scheduleRender);

  // ---- Hover magnifier (loupe) ----
  // A floating circular lens that samples the high-res preview (the live canvas, or the
  // static example image for coming-soon styles) so the customer can read the small
  // footer names/flowers text. View-only: never touches render data. Desktop hover only
  // -- skipped on touch/coarse pointers (there's no hover, and the CSS hides it too).
  (function setupLoupe() {
    var loupe = document.getElementById("fb-loupe");
    if (!loupe || !canvasWrapEl || !loupe.getContext) return;
    var lctx = loupe.getContext("2d");
    var ZOOM = 2.8;
    var raf = null, lastX = 0, lastY = 0, loupeTouch = false;

    function loupeSource() {
      if (canvas && canvas.style.visibility !== "hidden" && canvas.width && canvas.height) return canvas;
      var st = document.getElementById("fb-static-preview");
      if (st && st.style.display !== "none" && st.complete && st.naturalWidth) return st;
      return null;
    }
    function drawLoupe() {
      raf = null;
      var src = loupeSource();
      var rect = canvasWrapEl.getBoundingClientRect();
      if (!src || !rect.width) { loupe.style.display = "none"; return; }
      var relX = (lastX - rect.left) / rect.width, relY = (lastY - rect.top) / rect.height;
      if (relX < 0 || relX > 1 || relY < 0 || relY > 1) { loupe.style.display = "none"; return; }
      var sw = src.naturalWidth || src.width, sh = src.naturalHeight || src.height;
      var lw = loupe.offsetWidth || 190, lh = loupe.offsetHeight || 190;
      // Crop size in SOURCE pixels for a true ZOOM× magnification relative to what's on
      // screen: show a (lens / ZOOM) on-screen region, converted into the source's own
      // pixel space via (source px / displayed px). Using sw/ZOOM directly ignored the
      // canvas dpr backing store, so the crop was almost the whole poster -> no zoom.
      var cropW = (lw / ZOOM) * (sw / rect.width);
      var cropH = (lh / ZOOM) * (sh / rect.height);
      cropW = Math.min(cropW, sw); cropH = Math.min(cropH, sh);
      var cx = Math.max(0, Math.min(sw - cropW, relX * sw - cropW / 2));
      var cy = Math.max(0, Math.min(sh - cropH, relY * sh - cropH / 2));
      lctx.clearRect(0, 0, loupe.width, loupe.height);
      try { lctx.drawImage(src, cx, cy, cropW, cropH, 0, 0, loupe.width, loupe.height); }
      catch (e) { loupe.style.display = "none"; return; }
      // On touch, lift the lens ABOVE the finger so it doesn't cover what you're reading.
      var offY = loupeTouch ? (lh / 2 + 30) : 0;
      loupe.style.left = (lastX - rect.left - lw / 2) + "px";
      loupe.style.top = (lastY - rect.top - lh / 2 - offY) + "px";
      loupe.style.display = "block";
    }
    function hideLoupe() {
      if (raf != null) { cancelAnimationFrame(raf); raf = null; }
      loupe.style.display = "none";
    }
    // Desktop: hover to magnify.
    canvasWrapEl.addEventListener("mousemove", function (e) {
      loupeTouch = false; lastX = e.clientX; lastY = e.clientY;
      if (raf == null) raf = requestAnimationFrame(drawLoupe);
    });
    canvasWrapEl.addEventListener("mouseleave", hideLoupe);
    // Mobile: touch-and-HOLD to magnify, lift finger to dismiss. We engage only after a
    // short hold so a normal swipe on the canvas still SCROLLS the page (immediate
    // preventDefault would trap the scroll and make the page feel stuck). Once engaged,
    // moving pans the lens; before that, movement past a small threshold cancels (= scroll).
    var holdTimer = null, engaged = false, startX = 0, startY = 0;
    function engageLoupe() {
      engaged = true; loupeTouch = true;
      if (raf == null) raf = requestAnimationFrame(drawLoupe);
    }
    function endTouch() {
      if (holdTimer) { clearTimeout(holdTimer); holdTimer = null; }
      engaged = false; hideLoupe();
    }
    canvasWrapEl.addEventListener("touchstart", function (e) {
      if (!e.touches || !e.touches[0]) return;
      var tch = e.touches[0];
      startX = lastX = tch.clientX; startY = lastY = tch.clientY;
      engaged = false;
      if (holdTimer) clearTimeout(holdTimer);
      holdTimer = setTimeout(engageLoupe, 180);
    }, { passive: true });
    canvasWrapEl.addEventListener("touchmove", function (e) {
      if (!e.touches || !e.touches[0]) return;
      var tch = e.touches[0];
      if (!engaged) {
        // Moved before the hold fired -> it's a scroll: cancel and let the page move.
        if (Math.abs(tch.clientX - startX) > 10 || Math.abs(tch.clientY - startY) > 10) {
          if (holdTimer) { clearTimeout(holdTimer); holdTimer = null; }
        }
        return;
      }
      lastX = tch.clientX; lastY = tch.clientY;
      if (raf == null) raf = requestAnimationFrame(drawLoupe);
      if (e.cancelable) e.preventDefault(); // engaged: pan the lens, don't scroll
    }, { passive: false });
    canvasWrapEl.addEventListener("touchend", endTouch);
    canvasWrapEl.addEventListener("touchcancel", endTouch);
  })();

  // ---- Mobile sticky mini-preview + return toggle ----
  // Mirrors single-flower-poster: on mobile a fixed thumbnail follows the poster as you
  // scroll through the builder. Tap it to jump up to the canvas; a "return" chip then
  // jumps you back to EXACTLY where you were editing (saved scroll position), so you can
  // go back and forth. Desktop: CSS hides both, so this is a no-op there.
  var miniEl = document.getElementById("fb-mini-preview");
  var miniCanvas = document.getElementById("fb-mini-canvas");
  var miniCtx = miniCanvas ? miniCanvas.getContext("2d") : null;
  var returnEl = document.getElementById("fb-mini-return");
  var miniSavedY = null;

  function syncMiniBouquet() {
    if (!miniCtx || !canvas || !canvas.width) return;
    if (miniCanvas.width !== canvas.width || miniCanvas.height !== canvas.height) {
      miniCanvas.width = canvas.width; miniCanvas.height = canvas.height;
      miniCanvas.style.aspectRatio = canvas.width + " / " + canvas.height;
    }
    miniCtx.clearRect(0, 0, miniCanvas.width, miniCanvas.height);
    try { miniCtx.drawImage(canvas, 0, 0); } catch (e) {}
  }

  if (miniEl && canvasWrapEl && "IntersectionObserver" in window) {
    var miniObs = new IntersectionObserver(function (entries) {
      var canvasVisible = entries[0].isIntersecting;
      // Canvas out of view -> show the mini thumbnail. Canvas in view (top) -> show the
      // return chip, but only once the user has actually jumped up via the mini (so it
      // isn't offering a "return" on first page load).
      miniEl.classList.toggle("is-visible", !canvasVisible);
      miniEl.setAttribute("aria-hidden", String(canvasVisible));
      if (returnEl) {
        var showReturn = canvasVisible && miniSavedY != null;
        returnEl.classList.toggle("is-visible", showReturn);
        returnEl.setAttribute("aria-hidden", String(!showReturn));
      }
    }, { threshold: 0.15 });
    miniObs.observe(canvasWrapEl);

    miniEl.addEventListener("click", function () {
      miniSavedY = window.scrollY || window.pageYOffset || 0;
      canvasWrapEl.scrollIntoView({ behavior: "smooth", block: "start" });
    });
    if (returnEl) returnEl.addEventListener("click", function () {
      window.scrollTo({ top: (miniSavedY != null ? miniSavedY : 0), behavior: "smooth" });
    });
  }

  // Let the next fbBoot() (theme-editor section re-render) detach this instance's
  // window-level listeners so they don't stack.
  window.__fbTeardown = function () {
    window.removeEventListener("keydown", onDevKeydown);
    window.removeEventListener("resize", scheduleRender);
  };

  var verEl = document.getElementById("fb-dev-version");
  if (verEl) verEl.textContent = FB_SECTION_VERSION + (R && R.VERSION ? " / " + R.VERSION : "");

  // Wire up click handlers immediately — don't wait for palette/renderer
  restoreDevState();
  // Apply the full adjustments stack for the initially selected style (factory reset ->
  // section setting + session backup -> the style's own overrides). Must come after
  // restoreDevState so a theme-editor-restored bgKey gets ITS style's positions.
  applyStyleAdjustments();
  renderChoices();
  applyLanguage(); // sync card labels + renderer registry to the poster language (also runs renderSlots)
  // Frame add-on: price the tiles for the initially-selected size, and re-run the CTA price
  // whenever the customer's frame selection changes.
  if (window.TBPFrame && window.TBPFrame.setSize) window.TBPFrame.setSize(getSelectedSize());
  if (window.TBPFrame && window.TBPFrame.onChange) window.TBPFrame.onChange(function () { updateCartPrice(); });
  updateCartPrice();
  if (devMode) refreshDevJson();

  // Async stuff (palette, fonts, preview) can load in background
  (async () => {
    try {
      await renderColorSwatches();
    } catch(e) { console.warn("[FB] Color swatches error:", e); }
    try { renderBackgroundPicker(); } catch(e) { console.warn("[FB] BG picker error:", e); }
    try {
      if (R && R.ensureFontLoaded) await R.ensureFontLoaded();
    } catch(e) { console.warn("[FB] Font error:", e); }
    updatePreviewMode(); // static styles show their fixed image instead of rendering
    scheduleRender();
  })();
  } // end fbBoot

  // ---- Dev unlock gate (cached; runs before every boot) ----
  // Unlocked when: theme-editor design mode (staff login already required), OR the
  // URL fragment (e.g. #fb-dev-xxxx) SHA-256-hashes to the section's dev_token_hash
  // setting. Fragments never reach the server, logs, sitemaps, or crawlers, and the
  // page only carries the digest -- view-source reveals nothing usable. No fragment
  // = an already-resolved false promise, so customers pay zero cost. Changing the
  // fragment requires a reload (the verdict is cached for section re-renders).
  var __fbDevUnlock = null;
  function fbCheckDevUnlock() {
    if (__fbDevUnlock) return __fbDevUnlock;
    __fbDevUnlock = (function () {
      try {
        if (window.Shopify && window.Shopify.designMode) return Promise.resolve(true);
        var frag = String(window.location.hash || "").replace(/^#/, "");
        if (!frag) return Promise.resolve(false);
        var cfgEl = document.getElementById("fb-flowers-json");
        var want = "";
        try { want = String(JSON.parse((cfgEl && cfgEl.textContent) || "{}").devTokenHash || "").trim().toLowerCase(); } catch (e) {}
        if (!want || !(window.crypto && window.crypto.subtle) || !window.TextEncoder) return Promise.resolve(false);
        return window.crypto.subtle.digest("SHA-256", new TextEncoder().encode(frag)).then(function (buf) {
          var hex = Array.prototype.map.call(new Uint8Array(buf), function (b) { return ("0" + b.toString(16)).slice(-2); }).join("");
          return hex === want;
        }).catch(function () { return false; });
      } catch (e) { return Promise.resolve(false); }
    })();
    return __fbDevUnlock;
  }
  function fbBootGated() {
    fbCheckDevUnlock().then(function (ok) {
      window.__fbDevToolsUnlocked = !!ok;
      fbBoot();
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", fbBootGated);
  } else {
    fbBootGated();
  }
  // Theme editor: any setting change (e.g. background zoom) re-renders the section's
  // HTML after DOMContentLoaded already fired -- without this, the fresh DOM sits on
  // its "Loading & rendering…" overlay forever because nothing re-initializes it.
  if (!window.__fbSectionHookInstalled) {
    window.__fbSectionHookInstalled = true;
    document.addEventListener("shopify:section:load", function (e) {
      if (e.target && e.target.querySelector && e.target.querySelector("#fb-canvas")) fbBootGated();
    });
  }
})();
